import { Component, Inject, OnInit, OnDestroy, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImportExcelComponent } from '../commonImport/import-excel/import-excel.component';
import { DatePipe } from '@angular/common';
import { FormArray, FormBuilder, FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { Constant } from 'src/app/constant/constant';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { CommonDownloadService } from 'src/app/services/common-download.service';
import { ProductService } from 'src/app/services/product.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { take, takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { GroupByReportService } from 'src/app/services/group-by-report.service';
import { UsersService } from 'src/app/services/users.service';
import { FollowActivityReportService } from 'src/app/services/follow-activity-report.service';
import { LeadCallReportService } from 'src/app/services/lead-call-report.service';
import { LeadFormIdReportService } from 'src/app/services/lead-form-id-report.service';
import { LeadUserFormIdReportService } from 'src/app/services/lead-user-form-id-report.service';
import { LeadCallWithOutGroupByReportService } from 'src/app/services/lead-call-with-out-group-by-report.service';
import { ActivityService } from 'src/app/services/activity.service';
import { ClientUserActivityReportService } from 'src/app/services/client-user-activity-report.service';
import { HousingBuilderService } from 'src/app/services/housing-builder.service';
import { SupplierService } from 'src/app/services/supplier.service';
import { DealsService } from 'src/app/services/deals.service';
import { ContactsService } from 'src/app/services/contacts.service';
import { PatientService } from 'src/app/services/patient.service';
import { TaskService } from 'src/app/services/task.service';
import { CourseReportsService } from 'src/app/services/course-reports.service';
import { CourseItemHistoryReportService } from 'src/app/services/course-item-history-report.service';
import { CoursehistoryreportService } from 'src/app/services/coursehistoryreport.service';
import { UserAttendenceReportService } from 'src/app/services/user-attendence-report-service';
import { DialerReportService } from 'src/app/services/dialer-report.service';
import { DialersReportService } from 'src/app/services/dialers-report.service';
import { DialerTotalDurationByUserReportService } from 'src/app/services/dialer-total-duration-by-user-report.service';
import { SupplierCommisionReportService } from 'src/app/services/supplier-commision-report.service';
import { VendorWiseQtyReportService } from 'src/app/services/vendor-wise-qty-report.service';
import { SupplierPaymentReportService } from 'src/app/services/supplier-payment-report.service';
import { CatalogSearchReportService } from 'src/app/services/catalog-search-report.service';
import { SalesByProductVariantSkuService } from 'src/app/services/sales-by-product-variant-sku.service';
import { TaxReportService } from 'src/app/services/tax-report.service';
import { TransactionHistoryReportService } from 'src/app/services/transaction-history-report.service';
import { OverAllDiscountCouponReportService } from 'src/app/services/over-all-discount-coupon-report.service';
import { UserCouponReportService } from 'src/app/services/user-coupon-report.service';
import { IndividualCustomerReportService } from 'src/app/services/individual-customer-report.service';
import { HrmLocationService } from 'src/app/services/hrm-location.service';
import { HrmDepartmentService } from 'src/app/services/hrm-department.service';
import { LeadproductwisereportService } from 'src/app/services/leadproductwisereport.service';
import { DuplicateLeadService } from 'src/app/services/duplicate-lead.service';
import { LoanpendinglistreportService } from 'src/app/services/loanpendinglistreport.service';
import { GoldLoanActiveListReportService } from 'src/app/services/gold-loan-active-list-report.service';
import { GoldloancompletedlistService } from 'src/app/services/goldloancompletedlist.service';
import { GoldActivityService } from 'src/app/services/gold-activity.service';
import { MlmUserreportService } from 'src/app/services/mlm-userreport.service';
import { MlmOrderreportService } from 'src/app/services/mlm-orderreport.service';
import { KitchenMosterService } from 'src/app/services/kitchen-moster.service';
import { SuspensCategoriesService } from 'src/app/services/suspens-categories.service';
import { ExpenseCategoryService } from 'src/app/services/expense-category.service';
import { BrandService } from 'src/app/services/brand.service';
import { UnitsService } from 'src/app/services/units.service';
import { PoscurriencesService } from 'src/app/services/poscurriences.service';
import { GiftcardsService } from 'src/app/services/giftcards.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { SaleOrderService } from 'src/app/services/sale-order.service';
import { DiningtablesService } from 'src/app/services/diningtables.service';
import { PosPurchaseService } from 'src/app/services/pos-purchase.service';
import { GoodsreceivedService } from 'src/app/services/goodsreceived.service';
import { CategoriesService } from 'src/app/services/categories.service';
import { PoswarehouseService } from 'src/app/services/poswarehouse.service';
import { PosproductService } from 'src/app/services/posproduct.service';
import { PostaxRateService } from 'src/app/services/postax-rate.service';
import { PosSupplierService } from 'src/app/services/pos-supplier.service';
import { QuantityAdjustmentsService } from 'src/app/services/quantity-adjustments.service';
import { ExpensesService } from 'src/app/services/expenses.service';
import { PosSalesService } from 'src/app/services/pos-sales.service';
import { QuotationService } from 'src/app/services/quotations.service';
import { TransfersService } from 'src/app/services/transfers.service';
import { SalesReturnService } from 'src/app/services/sales-return.service';
import { SupplierReportService } from 'src/app/services/supplier-report.service';
import { SupplierProductsReportService } from 'src/app/services/supplier-products-report.service';
import { RegisterReportService } from 'src/app/services/register-report.service';
import { ProductsReportService } from 'src/app/services/products-report.service';
import { AdjustmentsReportService } from 'src/app/services/adjustments-report.service';
import { CategoriesReportService } from 'src/app/services/categories-report.service';
import { BrandsReportService } from 'src/app/services/brands-report.service';
import { BankTransactionReportService } from 'src/app/services/bank-transaction-report.service';
import { PaymentsReportService } from 'src/app/services/payments-report.service';
import { TaxRateReportService } from 'src/app/services/tax-rate-report.service';
import { PosExpenseReportService } from 'src/app/services/pos-expense-report.service';
import { PurchasesReportService } from 'src/app/services/purchases-report.service';
import { ProfitByProductReportService } from 'src/app/services/profit-by-product-report.service';
import { WarehouseTransactionsReportService } from 'src/app/services/warehouse-transactions-report.service';
import { DeletedentriesreportsService } from 'src/app/services/deletedentriesreports.service';
import { ProductQuantityAlertsService } from 'src/app/services/product-quantity-alerts.service';
import { TodayLeadScoringReportService } from 'src/app/services/today-lead-scoring-report.service';
import { LeadScoringReportService } from 'src/app/services/lead-scoring-report.service';
import { LeadIdByLeadScoreReportService } from 'src/app/services/lead-id-by-lead-score-report.service';
import { RefferalCommissionReportService } from 'src/app/services/refferal-commission-report.service';
import { StaffReportService } from 'src/app/services/staff-report.service';
import { GoogleCalendarReportService } from 'src/app/services/google-calendar-report.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { UsercallreportService } from 'src/app/services/usercallreport.service';
import { LeadUserSourceStatusReportService } from 'src/app/services/lead-user-source-status-report.service';
import { DealsGroupWiseReportService } from 'src/app/services/deals-group-wise-report.service';
import { DelasUserWiseReportService } from 'src/app/services/delas-user-wise-report.service';
import { LeadStatusReportService } from 'src/app/services/lead-status-report.service';
import { LeadOwnerService } from 'src/app/services/lead-owner.service';
import { ProductQtyAndExpiryAlertsReportService } from 'src/app/services/product-qty-and-expiry-alerts-report.service';
import { CustomersreportService } from 'src/app/services/customersreport.service';
import { SalesReportService } from 'src/app/services/sales-report.service';
import { LeadCallOverViewReportService } from 'src/app/services/lead-call-over-view-report.service';
import { DistributorAnalysisCountReportService } from 'src/app/services/distributor-analysis-count-report.service';
import { CallStageProductivityPendingAndFollowReportService } from 'src/app/services/call-stage-productivity-pending-and-follow-report.service';
import { ProductExpiryAlertsService } from 'src/app/services/product-expiry-alerts.service';
import { PosCustomersReportService } from 'src/app/services/pos-customers-report.service';
import { HrmDailyUserTimeSummaryReportService } from 'src/app/services/hrm-daily-user-time-summary-report.service';
import { HrmProjectStatusReportService } from 'src/app/services/hrm-project-status-report.service';
import { WhatsappcontactService } from 'src/app/services/whatsappcontact.service';
import { UserMailConfigService } from 'src/app/services/user-mail-config.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { WhatsappCampaignService } from 'src/app/services/whatsapp-campaign.service';
import { LeadStatusOverAllReportService } from 'src/app/services/lead-status-over-all-report.service';
import { TasksByOwnerReportService } from 'src/app/services/tasks-by-owner-report.service';
import { ClosedReportByLeadSourceService } from 'src/app/services/closed-report-by-lead-source.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { WhatsappMessageLogsReportService } from 'src/app/services/whatsapp-message-logs-report.service';
import { BotRepliesService } from 'src/app/services/bot-replies.service';
import { WhatsappTemplateService } from 'src/app/services/whatsapp-template.service';
import { WhatsAppContactGroupService } from 'src/app/services/whats-app-contact-group.service';
import { BotFlowsService } from 'src/app/services/bot-flows.service';
import { CustomerOrderReportService } from 'src/app/services/customer-order-report.service';
import { CallConnectionSummaryService } from 'src/app/services/call-connection-summary.service';
import { ChatContactsService } from 'src/app/services/chat-contacts.service';
import { SalesTargetReportService } from 'src/app/services/sales-target-report.service';
import { ChatBotRepliesService } from 'src/app/services/chat-bot-replies.service';
import { ChatBotFlowsService } from 'src/app/services/chat-bot-flows.service';
import { SequenceActivityGroupByReportService } from 'src/app/services/sequence-activity-group-by-report.service';
import { CompaniesService } from 'src/app/services/companies.service';
import { UserWebActivityReportService } from 'src/app/services/user-web-activity-report.service';
import { UserWebActivityClientReportService } from 'src/app/services/user-web-activity-client-report.service';
import { UpcomingAccountRenewalService } from 'src/app/services/upcoming-account-renewal.service';
import { SourceStatusService } from 'src/app/services/source-status.service';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { ClientActivityReportService } from 'src/app/services/client-activity-report.service';
import { MeetingSummaryForLeadsAndDealsReportService } from 'src/app/services/meeting-summary-for-leads-and-deals-report.service';
import { LeadsAndDealsWithCalenderReportService } from 'src/app/services/leads-and-deals-with-calender-report.service';
import { LeadTaskReportService } from 'src/app/services/lead-task-report.service';
import { PaymentTypeService } from 'src/app/services/payment-type.service';
import { UserDeviceActivityReportService } from 'src/app/services/user-device-activity-report.service';
import { TaskReportService } from 'src/app/services/task-report.service';
import { IndustryTypeService } from 'src/app/services/industry-type.service';
import { BussinessTypeService } from 'src/app/services/bussiness-type.service';
import { WhatsappMessageLogsService } from 'src/app/services/whatsapp-message-logs.service';
import { NeverAttendedService } from 'src/app/services/never-attended.service';
import { CallHistoryService } from 'src/app/services/call-history.service';
import { WorkSessionReportService } from 'src/app/services/work-session-report.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { SalesCallHistorySummaryReportService } from 'src/app/services/sales-call-history-summary-report.service';
import { RealEstatePropertyService } from 'src/app/services/real-estate-property.service';


@Component({
  selector: 'calsoft-common-download',
  templateUrl: './common-download.component.html',
  styleUrls: ['./common-download.component.scss'],
  providers: [DatePipe]
})
export class CommonDownloadComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  data: any;
  searchValues: any;
  filterSelectObj: any = [];
  colummnToBeRemoved: any = [];
  searchTermPresent: any = false;
  searchTermMain: any;
  searchTermMainEmit: any = 0;
  searchTermEmit: any = 0;
  searchTerm: string = undefined;
  searchTermMainPresent: any = true;
  downloadData: any = [];
  totalElements: number = 0;
  totalPages: number = 0;
  spinner: boolean;
  useDefaultHeading: any = false;
  url2: any;
  header: any;
  headerName: any;
  downloadFileName: any;
  filtereddropdownTypeList: any;
  filteredUserCallStatusTypeList: any;
  groupBy: any = '';
  type: any;
  selectedValues = [];
  sortObject: any = [];
  solrUrl: boolean;

  hoursList = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
  minutesList = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  ampmList = ['AM', 'PM'];
  timeValues: { hh: string, mm: string, ampm: string }[] = [];
  private servicesMap: Map<string, any>;
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) data,
    public datepipe: DatePipe,
    private commonDownload: CommonDownloadService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private productService: ProductService,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    private usersService: UsersService,
    private groupByReportService: GroupByReportService,
    private followActivityReportService: FollowActivityReportService,
    private leadCallReportService: LeadCallReportService,
    private leadCallWithOutGroupByReportService: LeadCallWithOutGroupByReportService,
    private leadFormIdReportService: LeadFormIdReportService,
    private leadUserFormIdReportService: LeadUserFormIdReportService,
    private clientUserActivityReportService: ClientUserActivityReportService,
    private activityService: ActivityService,
    private housingBuilderService: HousingBuilderService,
    private supplierService: SupplierService,
    private dealsService: DealsService,
    private contactsService: ContactsService,
    private patientService: PatientService,
    private taskService: TaskService,
    private courseReportsService: CourseReportsService,
    private courseItemHistoryReportService: CourseItemHistoryReportService,
    private coursehistoryreportService: CoursehistoryreportService,
    private userAttendenceReportService: UserAttendenceReportService,
    private userService: UsersService,
    private dialerReportService: DialerReportService,
    private dialersReportService: DialersReportService,
    private dialerTotalDurationByUserReportService: DialerTotalDurationByUserReportService,
    private supplierCommisionReportService: SupplierCommisionReportService,
    private vendorWiseQtyReportService: VendorWiseQtyReportService,
    private supplierPaymentReportService: SupplierPaymentReportService,
    private catalogSearchReportService: CatalogSearchReportService,
    private salesByProductVariantSkuService: SalesByProductVariantSkuService,
    private taxReportService: TaxReportService,
    private transactionHistoryReportService: TransactionHistoryReportService,
    private overAllDiscountCouponReportService: OverAllDiscountCouponReportService,
    private individualCustomerReportService: IndividualCustomerReportService,
    private userCouponReportService: UserCouponReportService,
    private hrmLocationService: HrmLocationService,
    private hrmDepartmentService: HrmDepartmentService,
    private leadproductwisereportService: LeadproductwisereportService,
    private loanpendinglistreportService: LoanpendinglistreportService,
    private duplicateLeadService: DuplicateLeadService,
    private goldLoanActiveListReportService: GoldLoanActiveListReportService,
    private goldloancompletedlistService: GoldloancompletedlistService,
    private goldActivityService: GoldActivityService,
    private mlmUserreportService: MlmUserreportService,
    private mlmOrderreportService: MlmOrderreportService,
    private kitchenMosterService: KitchenMosterService,
    private suspensCategoriesService: SuspensCategoriesService,
    private expenseCategoryService: ExpenseCategoryService,
    private unitsService: UnitsService,
    private sourceService: LeadUserSourceStatusReportService,
    private brandService: BrandService,
    private poscurriencesService: PoscurriencesService,
    private purchaseOrderService: PurchaseOrderService,
    private giftcardsService: GiftcardsService,
    private saleOrderService: SaleOrderService,
    private diningtablesService: DiningtablesService,
    private posPurchaseService: PosPurchaseService,
    private goodsreceivedService: GoodsreceivedService,
    private categoriesService: CategoriesService,
    private poswarehouseService: PoswarehouseService,
    private posproductService: PosproductService,
    private postaxRateService: PostaxRateService,
    private posSupplierService: PosSupplierService,
    private quantityAdjustmentsService: QuantityAdjustmentsService,
    private expensesService: ExpensesService,
    private posSalesService: PosSalesService,
    private quotationService: QuotationService,
    private transfersService: TransfersService,
    private salesReturnService: SalesReturnService,
    private supplierReportService: SupplierReportService,
    private supplierProductsReportService: SupplierProductsReportService,
    private registerReportService: RegisterReportService,
    private productsReportService: ProductsReportService,
    private adjustmentsReportService: AdjustmentsReportService,
    private categoriesReportService: CategoriesReportService,
    private brandsReportService: BrandsReportService,
    private profitByProductReportService: ProfitByProductReportService,
    private warehouseTransactionsReportService: WarehouseTransactionsReportService,
    private deletedentriesreportsService: DeletedentriesreportsService,
    private bankTransactionReportService: BankTransactionReportService,
    private paymentsReportService: PaymentsReportService,
    private taxRateReportService: TaxRateReportService,
    private posExpenseReportService: PosExpenseReportService,
    private purchasesReportService: PurchasesReportService,
    private productQuantityAlertsService: ProductQuantityAlertsService,
    private todayLeadScoringReportService: TodayLeadScoringReportService,
    private leadScoringReportService: LeadScoringReportService,
    private leadIdByLeadScoreReportService: LeadIdByLeadScoreReportService,
    private refferalCommissionReportService: RefferalCommissionReportService,
    private staffReportService: StaffReportService,
    private googleCalendarReportService: GoogleCalendarReportService,
    private callStageProductivityPendingAndFollowService: CallStageProductivityPendingAndFollowReportService,
    private registrationService: RegistrationService,
    private usercallreportService: UsercallreportService,
    private leadUserSourceStatusReportService: LeadUserSourceStatusReportService,
    private dealsGroupWiseReportService: DealsGroupWiseReportService,
    private delasUserWiseReportService: DelasUserWiseReportService,
    private statusService: LeadStatusReportService,
    private leadOwnerService: LeadOwnerService,
    private productQtyAndExpiryAlertsReportService: ProductQtyAndExpiryAlertsReportService,
    private customersreportService: CustomersreportService,
    private productExpiryAlertsService: ProductExpiryAlertsService,
    private salesReportService: SalesReportService,
    private distributorAnalysisService: DistributorAnalysisCountReportService,
    private leadCallOverViewReportService: LeadCallOverViewReportService,
    private posCustomersReportService: PosCustomersReportService,
    private hrmDailyUserTimeSummaryReportService: HrmDailyUserTimeSummaryReportService,
    private hrmProjectStatusReportService: HrmProjectStatusReportService,
    private whatsappContactService: WhatsappcontactService,
    private projectsService: ProjectsService,
    private whatsAppCampaignService: WhatsappCampaignService,
    private leadStatusOverAllReportService: LeadStatusOverAllReportService,
    private tasksByOwnerReportService: TasksByOwnerReportService,
    private closedReportByLeadSourceService: ClosedReportByLeadSourceService,
    private tagesStatusService: TagesStatusService,
    private botRepliesService: BotRepliesService,
    private whatsappMessageLogsReportService: WhatsappMessageLogsReportService,
    private whatsappTemplateService: WhatsappTemplateService,
    private whatsAppContactGroupService: WhatsAppContactGroupService,
    private botFlowsService: BotFlowsService,
    private callConnectionSummaryService: CallConnectionSummaryService,
    private customerOrderReportService: CustomerOrderReportService,
    private chatContactsService: ChatContactsService,
    private salesTargetReportService: SalesTargetReportService,
    private chatBotRepliesService: ChatBotRepliesService,
    private chatBotFlowsService: ChatBotFlowsService,
    private sequenceActivityGroupByReportService: SequenceActivityGroupByReportService,
    private companiesService: CompaniesService,
    private userWebActivityReportService: UserWebActivityReportService,
    private userWebActivityClientReportService: UserWebActivityClientReportService,
    private upcomingAccountRenewalService: UpcomingAccountRenewalService,
    private sourceStatusService: SourceStatusService,
    private clientActivityReportService: ClientActivityReportService,
    private leadsAndDealsWithCalenderReportService: LeadsAndDealsWithCalenderReportService,
    private meetingSummaryForLeadsAndDealsReportService: MeetingSummaryForLeadsAndDealsReportService,
    private dealsStageService: DealsStageService,
    private leadTaskReportService: LeadTaskReportService,
    private paymentTypeService: PaymentTypeService,
    private userDeviceActivityReportService: UserDeviceActivityReportService,
    private taskReportService: TaskReportService,
    private industryTypeService: IndustryTypeService,
    private bussinessTypeService: BussinessTypeService,
    private whatsappMessageLogsService: WhatsappMessageLogsService,
    private callHistoryService: CallHistoryService,
    private neverAttendedService: NeverAttendedService,
    private workSessionReportService: WorkSessionReportService,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private salesCallHistorySummaryReportService: SalesCallHistorySummaryReportService,
    private propertyService: RealEstatePropertyService,
    private snackBar: MatSnackBar,
    @Optional() private dialogRef: MatDialogRef<CommonDownloadComponent>) {
    this.data = data;
    this.initializeServicesMap();

    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.filterSelectObj = this.data.obj ? this.data.obj.map((item: any) => ({ ...item })) : [];
    this.columns = this.data.columns;
    this.colummnToBeRemoved = this.data.colummnToBeRemoved;
    this.useDefaultHeading = this.data.useDefaultHeading;
    this.url2 = this.data.url2;
    this.header = this.data.header;
    this.data.service = this.data.service;
    this.headerName = this.data.headerName;
    this.downloadFileName = this.data.dowloadFileName;
    this.type = this.data.type == undefined ? 'normal' : this.data.type

    if (this.data.type != 'normal') {
      this.groupBy = this.data.groupByValue

    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });

  }

  downloadDataComplete: string = 'OK';

  firstFormGroup = this._formBuilder.group({
    page: [''],
    size: [''],
    sort: ['', Validators.required],
    sortBy: ['0'],
    downloadMode: ['default']

  });

  booleanField: any = [
    { "value": "asc", "viewValue": "ASC" },
    { "value": "desc", "viewValue": "DESC" },
  ]


  downloadMode: any = [
    { "value": "default", "viewValue": "Default" },
    { "value": "all", "viewValue": "All Data" },
  ]

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  ngOnInit() {
    const currentUrl = this.router.url.split('?')[0];

    // Check if the current page uses Solr for data fetching
    const solrPages = ['/lead', '/companies', '/deals', '/contact', '/contacts'];
    this.solrUrl = solrPages.includes(currentUrl);
    this.resetFilters();

    this.initializeForm();
    let indexForleadStatus = this.filterSelectObj.findIndex(x => x.name == 'Status Name')
    if (indexForleadStatus > -1) {
      this.getLeadDropDownList();
    } else {
      indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'statusName')
      if (indexForleadStatus > -1) {
        this.getLeadDropDownList();
      } else {
        indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'c.status_name' || x.name == 'Lead Status')
        if (indexForleadStatus > -1) {
          this.getLeadDropDownList();
        }
      }


    }


    let indexForDealStage = this.filterSelectObj.findIndex(x => x.name == 'Stage'
      || x.name == 'Stage Name'
      || x.name == 'Deal Stage')
    if (indexForDealStage > -1) {
      console.log("sa");

      this.getDealStage();
    }


    let indexForLoacation = this.filterSelectObj.findIndex(x =>
      x.name == 'Location' ||
      x.name == 'Warehouse' ||
      x.name == 'Warehouse Name' ||
      x.property == 'warehouse' ||
      x.property == 'warehouseName' ||
      x.property == 'warehouseId'
    );
    if (indexForLoacation > -1 || this.data?.service === 'purchaseOrderService' || this.data?.service === 'posPurchaseService') {
      this.getAllWareHouseList();
    }

    let indexForTaxRate = this.filterSelectObj.findIndex(x => x.name == 'Tax Rate' || x.name == 'Tax Rate Name' || x.property == 'taxRateId' || x.property == 'tax');
    if (indexForTaxRate > -1 || this.data?.service === 'purchaseOrderService' || this.data?.service === 'posPurchaseService') {
      this.getAllTaxRateList();
    }

    let indexForSupplier = this.filterSelectObj.findIndex(x =>
      x.name == 'Suppliers' ||
      x.name == 'Supplier' ||
      x.property == 'supplier' ||
      x.property == 'supplierId' ||
      x.property == 'supplierName'
    );
    if (indexForSupplier > -1 || this.data?.service === 'purchaseOrderService' || this.data?.service === 'posPurchaseService') {
      this.getAllSupplierList();
    }

    let indexForleadSource = this.filterSelectObj.findIndex(x => x.name == 'Source Name')
    if (indexForleadSource > -1) {
      this.getLeadSourceDownList();
    } else {
      indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'sourceName')
      if (indexForleadSource > -1) {
        this.getLeadSourceDownList();
      } else {
        indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'g.source_name' || x.name == 'Lead Source')
        if (indexForleadSource > -1) {
          this.getLeadSourceDownList();
        }
      }


    }

    let indexForleadStage = this.filterSelectObj.findIndex(x => x.name == 'Life Stage')
    if (indexForleadStage > -1) {
      this.getLeadDropDownList();
    }

    let indexForTags = this.filterSelectObj.findIndex(x => x.name == 'Tags')
    if (indexForTags > -1) {
      this.getAllTags();
    } else {
      indexForTags = this.filterSelectObj.findIndex(x => x.property == 'tagName')
      if (indexForTags > -1) {
        this.getAllTags();
      }
    }


    let indexForTypeOfService = this.filterSelectObj.findIndex(x => x.name == 'Type of Service')
    if (indexForTypeOfService > -1) {
      this.getPaymentList();
    }
    let indexForleadUser = this.filterSelectObj.findIndex(x =>
      x.name == 'User Name' ||
      x.property == 'createdBy' ||
      x.property == 'created_by' ||
      x.property == 'a.created_by' ||
      x.property == 'ownerEmail' ||
      x.property == 'a.owner_id'
    );
    if (indexForleadUser > -1) {
      this.getUserDropDownList();
    }
    let indexForleadActivity = this.filterSelectObj.findIndex(x => x.name == 'Activity Type')
    if (indexForleadActivity > -1) {
      this.getLeadActivityTypeDownList();
    }

    let indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.name == 'Owner' || x.name == 'Created By')
    if (indexForleadUserOwner > -1) {
      this.getUserDropDownList();
    } else {
      indexForleadUserOwner = this.filterSelectObj.findIndex(x =>
        x.property == 'ownerEmail' ||
        x.property == 'a.created_by' ||
        x.property == 'createdBy' ||
        x.property == 'created_by' ||
        x.property == 'a.owner_id'
      );
      if (indexForleadUserOwner > -1) {
        this.getUserDropDownList();
      }


    }

    // Industry Type dropdown
    let indexForIndustry = this.filterSelectObj.findIndex(x => x.name == 'Industry Type' || x.property == 'industryType');
    if (indexForIndustry > -1) {
      this.getAllIndustry();
    }

    // Business Type dropdown
    let indexForBusiness = this.filterSelectObj.findIndex(x => x.name == 'Busniess Type' || x.property == 'businessType');
    if (indexForBusiness > -1) {
      this.getAllBusiness();
    }

    this.sortObject = this.filterSelectObj.filter(x => x.property !== 'disable' && x.type !== 'disable' && x.property !== 'favourite$n');

    let defaultSort = '';
    if (this.data.defaultSort) {
      defaultSort = this.data.defaultSort;
    } else if (this.sortObject.length > 0) {
      defaultSort = this.sortObject[0].property;
    } else if (this.filterSelectObj && this.filterSelectObj.length > 0) {
      defaultSort = this.filterSelectObj[0].property;
    }

    let defaultSortBy = '';
    if (this.data.defaultSortBy) {
      defaultSortBy = this.data.defaultSortBy;
    } else {
      defaultSortBy = this.booleanField[0].value;
    }

    this.firstFormGroup.patchValue({
      page: (this.page !== undefined && this.page !== null && this.page !== '') ? this.page : (Constant.PAGE ?? 0),
      size: (this.size !== undefined && this.size !== null && this.size !== '') ? this.size : (Constant.SIZE ?? 10),
      sort: defaultSort,
      sortBy: defaultSortBy
    });

    if (this.filterSelectObj) {
      this.timeValues = this.filterSelectObj.map(() => ({ hh: '', mm: '', ampm: 'AM' }));
    }

    //  console.log(this.filterSelectObj);
  }
  close() {
    this.dialogRef.close({ event: 'close', data: 'sd' })
  }

  onPageBlur() {
    const val = this.firstFormGroup.get('page')?.value;
    if (val === null || val === undefined || String(val).trim() === '' || isNaN(Number(val)) || Number(val) < 0) {
      const defaultPage = (this.page !== undefined && this.page !== null && this.page !== '') ? this.page : (Constant.PAGE ?? 0);
      this.firstFormGroup.patchValue({ page: defaultPage });
    }
  }

  onSizeBlur() {
    const val = this.firstFormGroup.get('size')?.value;
    if (val === null || val === undefined || String(val).trim() === '' || isNaN(Number(val)) || Number(val) <= 0) {
      const defaultSize = (this.size !== undefined && this.size !== null && this.size !== '') ? this.size : (Constant.SIZE ?? 10);
      this.firstFormGroup.patchValue({ size: defaultSize });
    }
  }

  filterColumnText(value, index, j) {
    if (value.code == 'Space' && (<HTMLInputElement>value['target']).value.length > 0) {

      (<HTMLInputElement>value['target']).value = (<HTMLInputElement>value['target']).value + Array(1).fill('\xa0').join('')
    }

    let finalValue = (<HTMLInputElement>value['target']).value;


    if (finalValue.trim().length > 0) {



      this.searchValues = value;
      if (value.code == 'Space' && (<HTMLInputElement>value['target']).value.trim().length > 0) {

        (<HTMLInputElement>value['target']).value = (<HTMLInputElement>value['target']).value = (<HTMLInputElement>value['target']).value + Array(1).fill('\xa0').join('')
      }
      let finalValue = (<HTMLInputElement>value['target']).value;


      console.log(finalValue + "sas");
      if (this[this.filterSelectObj[index].position] == null) {

        this[this.filterSelectObj[index].position] = finalValue != null ? finalValue : finalValue;

      }
      else {

        if (finalValue != undefined) {

          if (finalValue.length == 0) {
            this[this.filterSelectObj[index].position] = undefined;
          } else {
            this[this.filterSelectObj[index].position] = finalValue;
          }

        }
        else if (j.length == 0) {
          this[this.filterSelectObj[index].position] = undefined;
        }
        else if (this[this.filterSelectObj[index].position] != ''
          && this.filterSelectObj[index].type != 'select'
          && this[this.filterSelectObj[index].position].length > 1) {
          this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position].slice(0, -1);
        }
        else {
          this[this.filterSelectObj[index].position] = undefined;
        }

      }

      this.filterOutput();
    }
  }

  filterColumn(value, index, j) {

    let finalValue = value.value

    if (this[this.filterSelectObj[index].position] == null) {
      this[this.filterSelectObj[index].position] = finalValue;
    } else {
      if (finalValue == undefined && finalValue != 'ALL') {
        this[this.filterSelectObj[index].position] = finalValue;
      }
      else if (j.length == 0) {
        this[this.filterSelectObj[index].position] = undefined;
      }

      else if (this.filterSelectObj[index].type == 'select') {
        if (finalValue != 'ALL') {
          this[this.filterSelectObj[index].position] = finalValue;
        }
        else {
          this[this.filterSelectObj[index].position] = undefined;
        }
      }
      else {
        this[this.filterSelectObj[index].position] = undefined;
      }
    }
    this.filterOutput();
  }

  onTimeChange(index, filter) {
    const time = this.timeValues[index];
    if (time.hh && time.mm && time.ampm) {
      filter.modelValue = `${time.hh}:${time.mm} ${time.ampm}`;
      this[this.filterSelectObj[index].position] = filter.modelValue;
      this.filterOutput();
    }
  }

  filterOutput() {

    this.searchTerm = undefined;

    const isMeaningful = (val: any): boolean => {
      if (val === undefined || val === null) {
        return false;
      }
      if (Array.isArray(val)) {
        return val.some(item => {
          if (item === undefined || item === null) return false;
          const s = typeof item === 'string' ? item : String(item);
          return s.replace(/\*/g, '').trim().length > 0;
        });
      }

      const s = String(val).trim().toLowerCase();

      if (s === 'all') return false;

      if (s.replace(/\*/g, '').length === 0) return false;

      return true;


    };

    // this.filterSelectObj.forEach((element, indexForLoop) => {

    //   if (this[element['position']] != undefined) {
    //     if (this.searchTerm == undefined) {

    //       if (this.filterSelectObj[indexForLoop].type == 'price') {
    //         this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + this[element['position']];
    //       }
    //       else if (this.filterSelectObj[indexForLoop].type != 'select') {
    //         this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + "'*" + this[element['position']] + "*'"
    //       }
    //       else if (this.filterSelectObj[indexForLoop].type == 'select') {

    //         this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + this[element['position']];

    //       }
    //     }
    //     else {

    //       if (this.filterSelectObj[indexForLoop].type == 'price') {
    //         this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + this[element['position']];
    //       }
    //       else if (this.filterSelectObj[indexForLoop].type != 'select') {
    //         this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + "'*" +
    //           this[element['position']] + "*'"
    //       } else {
    //         this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + this[element['position']]

    //       }
    //     }

    //   }

    // });


    this.filterSelectObj.forEach((element, indexForLoop) => {
      const prop = this.filterSelectObj[indexForLoop].property;
      const type = this.filterSelectObj[indexForLoop].type;
      const val = this[element['position']];

      if (!isMeaningful(val)) {
        // skip values that are only wildcards or empty
        return;
      }

      // Build individual clause

      let clause = '';
      if (type == 'price') {
        clause = `${prop}:${val}`;
      } else if (type == 'time') {
        let val12 = this.convertTo12Hour(val);
        clause = `${prop}:'*${val12}*'`;
      } else if (type != 'select') {
        clause = `${prop}:'*${val}*'`;
      } else if (type == 'date') {
        clause = `${prop}:${val}`;
      }
      else {
        if (typeof val === 'string' && val.includes(' ')) {
          clause = `${prop}:'${val}'`;
        } else {
          clause = `${prop}:${val}`;
        }
      }



      if (this.searchTerm == undefined) {
        this.searchTerm = clause;
      } else {
        this.searchTerm = this.searchTerm + ' AND ' + clause;
      }
    });

    this.searchTermPresent = false;

  }

  resetFilters(): void {
    if (this.filterSelectObj) {
      this.filterSelectObj.forEach((element, index) => {
        element.modelValue = undefined;
        this[element['position']] = undefined;
        if (this.selectedValues && this.selectedValues[index]) {
          this.selectedValues[index] = [];
        }
      });
    }

    if (this.filtersForm && this.filtersForm.get('ranges')) {
      (this.filtersForm.get('ranges') as FormArray).controls.forEach(control => {
        control.patchValue({ start: null, end: null });
      });
    }

    if (this.timeValues) {
      this.timeValues = this.filterSelectObj.map(() => ({ hh: '', mm: '', ampm: 'AM' }));
    }

    this.searchTerm = undefined;
    this.searchTermPresent = false;
    this.filterOutput();
  }


  columns: ListColumn[];

  start(event, type, index) {
    event.value = this.datepipe.transform(event.value, 'yyyy-MM-dd');
    let startDate = event.value;

    this[this.filterSelectObj[index].position] = startDate;

    let stringToSplit = this[this.filterSelectObj[index].position].split("~");

  }


  filtersForm: UntypedFormGroup;
  initializeForm(): void {
    this.filtersForm = this._formBuilder.group({
      ranges: this._formBuilder.array([])
    });

    this.addDateRangeFormGroup();
  }

  addDateRangeFormGroup(): void {
    this.filterSelectObj.forEach(() => {
      const rangeGroup = this._formBuilder.group({
        start: [''],
        end: ['']
      });
      (this.filtersForm.get('ranges') as FormArray).push(rangeGroup);
    });
  }


  range: UntypedFormGroup;
  end(event, type, index) {

    event.value = this.datepipe.transform(event.value, 'yyyy-MM-dd');
    let endDate = event.value;


    if (this.filtersForm.value.ranges[index] != null && this.filtersForm.value.ranges[index] != null && endDate != null) {
      this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position] + '~' + endDate;
      this.filterOutput();
    }
    console.log(this.filtersForm);

  }


  searchFilter() {
    if (this.searchTerm !== undefined && this.searchTerm !== null && this.searchTerm !== '') {
      this.searchTermPresent = true;
      var rule = /\s{1,}/g;
      this.searchTerm = this.searchTerm.split(rule).join(" ");
    } else {
      this.searchTermPresent = false;
    }
    this.downLoadData();
  }

  downLoadData() {

    this.downloadDataComplete = "Processing";

    let sortField = this.firstFormGroup.value.sort;
    if (this.solrUrl && sortField && sortField.toString().includes('$n')) {
      sortField = sortField.toString().replace('$n', '');
    }

    let sortParam = sortField;
    if (this.firstFormGroup.value.sortBy == 'asc') {
      sortParam = sortParam + "," + Constant.Asc;
    } else if (this.firstFormGroup.value.sortBy == 'desc') {
      sortParam = sortParam + "," + Constant.Dsc;
    } else if (sortParam && !sortParam.includes(',')) {
      sortParam = sortParam + "," + Constant.Dsc;
    }
    this.downloadData = [];

    const service = this.getService(this.data.service);

    if (this.searchTerm && (this.router.url.includes('lead') || this.router.url.includes('deals') || this.router.url.includes('contacts') || this.router.url.includes('companies'))) {
      this.searchTerm = this.searchTerm.replace(/'/g, '');
    }

    let effectiveSearchTerm = this.searchTerm || (this.solrUrl ? '*:*' : null);
    let apiName = this.searchTermPresent ? this.data.url : (this.data.url2 || this.data.url);
    const currentUrl = this.router.url.split('?')[0];
    if (this.solrUrl && (currentUrl === '/contact' || currentUrl === '/contacts' || currentUrl.includes('contact'))) {
      apiName = this.data.url;
    }
    const method = service[apiName];
    if (currentUrl === '/contact' || currentUrl === '/contacts' || currentUrl.includes('contact')) {
      effectiveSearchTerm = (!effectiveSearchTerm || effectiveSearchTerm === '*:*')
        ? 'isClosedWon:*1,*'
        : effectiveSearchTerm + ' AND isClosedWon:*1,*';
    }

    if (!method) {
      console.error(`Method ${apiName} not found on service ${this.data.service}`);
      this.downloadDataComplete = 'OK';
      return;
    }

    let page = this.firstFormGroup.value.page;
    let size = this.firstFormGroup.value.size;

    if (page === null || page === undefined || String(page).trim() === '') {
      page = '0';
      this.firstFormGroup.get('page')?.setValue('0');
    }

    if (size === null || size === undefined || String(size).trim() === '') {
      size = '10';
      this.firstFormGroup.get('size')?.setValue('10');
    }




    const handleError = (err) => {
      console.error('Download error:', err);
      this.downloadDataComplete = 'OK';
    };

    const handleResponse = async (res) => {
      if (!this.solrUrl) {
        let content = res;
        if (res && res.data && Array.isArray(res.data)) {
          content = res.data;
        } else if (res && res.data && res.data.content) {
          content = res.data.content;
        } else if (res && res['content']) {
          content = res['content'];
        } else if (res && res.data) {
          content = res.data;
        }
        this.downloadData = content || [];
        if (this.data.service === 'purchaseOrderService' || this.data.service === 'posPurchaseService') {
          if (!this.taxRateList || this.taxRateList.length === 0) {
            try {
              const taxRes: any = await this.postaxRateService.getAllTaxDropDown().toPromise();
              this.taxRateList = taxRes || [];
            } catch (e) {
              console.error('Error loading tax rates for download:', e);
            }
          }
          if (!this.warehouseList || this.warehouseList.length === 0) {
            try {
              const whRes: any = await this.poswarehouseService.getAllWarehouseDropDown().toPromise();
              this.warehouseList = whRes || [];
            } catch (e) {
              console.error('Error loading warehouses for download:', e);
            }
          }
        }
        this.downloadDataFinal(this.downloadData);
      } else {
        this.downloadAll(res, sortParam);
      }
    };

    if (apiName === 'getCustomDynamicReport') {
      method.call(service, this.data.payload).subscribe(handleResponse, handleError);
      return;
    }

    if (method.length === 6) {
      method.call(service, effectiveSearchTerm, page, size, sortParam, this.groupBy, this.data.additionalQuery).subscribe(handleResponse, handleError);
    } else if (method.length === 5) {
      if (this.data?.additionalQuery !== undefined && this.data?.additionalQuery !== null && (this.data?.groupByValue === undefined || this.data?.groupByValue === '')) {
        method.call(service, effectiveSearchTerm, page, size, sortParam, this.data.additionalQuery).subscribe(handleResponse, handleError);
      } else {
        method.call(service, effectiveSearchTerm, page, size, sortParam, this.groupBy).subscribe(handleResponse, handleError);
      }
    } else if (method.length === 4) {
      method.call(service, effectiveSearchTerm, page, size, sortParam).subscribe(handleResponse, handleError);
    } else {
      method.call(service, page, size, sortParam).subscribe(handleResponse, handleError);
    }

  }

  downloadDataFinal(downLoadData) {
    if (downLoadData && !Array.isArray(downLoadData)) {
      downLoadData = [downLoadData];
    }

    if (!downLoadData || downLoadData.length === 0) {
      this.snackBar.open("No data found", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      this.downloadDataComplete = 'OK';
      if (this.dialogRef) {
        this.dialogRef.close({ event: 'close', data: 'sd' });
      }
      return;
    }

    const currentUrl = this.router.url.split('?')[0];

    // Solr responses for these modules are wrapped or need normalization
    if (currentUrl === '/lead' || currentUrl === '/companies' || currentUrl === '/deals' || currentUrl === '/contact' || currentUrl === '/contacts' || currentUrl.includes('contact')) {
      downLoadData = (downLoadData || [])
        .map(record => {
          if (!record) return null;
          let downloadData = (record.downloadList != null) ? { ...record.downloadList, _rawRecord: record } : { ...record, _rawRecord: record };
          if (record.description !== undefined && record.description !== null && !downloadData.Description && !downloadData.description) {
            downloadData.Description = record.description;
          }
          if (record.tagName) {
            downloadData['Tag Name'] = record.tagName;
          }
          return downloadData;
        })
        .filter(record => record != null);
    }

    if (this.data.service === 'leadCallWithOutGroupByReportService' || this.data.service === 'callHistoryService') {
      downLoadData = (downLoadData || []).map(record => {
        if (record && record.typeAndTime !== undefined && record.typeAndTime !== null) {
          const seconds = parseInt(record.typeAndTime, 10);
          if (!isNaN(seconds) && seconds >= 0) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = Math.floor(seconds % 60);
            record.typeAndTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
          }
        }
        if (record && record.schedule) {
          let url = record.schedule;
          const serverPath = environment.commonImageApi + '/courseAudio/';
          if (url.includes('flowzo.ai') || url.includes('calsoftgroup.com') || url.includes('localhost')) {
            const cid = localStorage.getItem(Constant.enterPriseKey);
            if (cid && !url.includes('cid=')) {
              url += (url.includes('?') ? '&' : '?') + 'cid=' + cid;
            }
          } else {
            url = serverPath + url;
            const cid = localStorage.getItem(Constant.enterPriseKey);
            if (cid && !url.includes('cid=')) {
              url += (url.includes('?') ? '&' : '?') + 'cid=' + cid;
            }
          }
          record.schedule = url;
        } else {
          if (record) record.schedule = '(No Recording)';
        }

        if (record) {
          // Explicit UI fallback logic to prevent 'undefined' values from triggering 
          // the case-insensitive fallback in jsonHeaderKeys, which inadvertently picks up internal DB numerical IDs.
          record.callType = record.callType || 'Manual';
          record.callOutcome = record.callOutcome || '--';
        }

        return record;
      });
    }

    if (this.data.service === 'leadCallOverViewReportService') {
      downLoadData = (downLoadData || []).map(record => {
        if (record && record.totalDuration !== undefined && record.totalDuration !== null) {
          const seconds = parseInt(record.totalDuration, 10);
          if (!isNaN(seconds) && seconds >= 0) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = Math.floor(seconds % 60);
            record.totalDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
          }
        }
        return record;
      });
    }

    if (this.data.service === 'callStageProductivityPendingAndFollowService') {
      downLoadData = (downLoadData || []).map(record => {
        const formatDuration = (val: any) => {
          if (val !== undefined && val !== null) {
            const seconds = parseInt(val, 10);
            if (!isNaN(seconds) && seconds >= 0) {
              const hours = Math.floor(seconds / 3600);
              const minutes = Math.floor((seconds % 3600) / 60);
              const remainingSeconds = Math.floor(seconds % 60);
              return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
            }
          }
          return val;
        };

        if (record) {
          record.totalCallDuration = formatDuration(record.totalCallDuration);
          record.incomingDurationToday = formatDuration(record.incomingDurationToday);
          record.outgoingDurationToday = formatDuration(record.outgoingDurationToday);
        }
        return record;
      });
    }

    if (this.data.service === 'leadOwnerService') {
      downLoadData = (downLoadData || []).map(record => {
        const formatDuration = (val: any) => {
          if (val !== undefined && val !== null) {
            const seconds = parseInt(val, 10);
            if (!isNaN(seconds) && seconds >= 0) {
              const hours = Math.floor(seconds / 3600);
              const minutes = Math.floor((seconds % 3600) / 60);
              const remainingSeconds = Math.floor(seconds % 60);
              return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
            }
          }
          return val;
        };

        if (record) {
          record.outgoingDuration = formatDuration(record.outgoingDuration);
          record.outgoingDurationToday = formatDuration(record.outgoingDurationToday);
          record.incomingDuration = formatDuration(record.incomingDuration);
          record.incomingDurationToday = formatDuration(record.incomingDurationToday);
          record.totalDuration = formatDuration(record.totalDuration);
          record.totalDurationToday = formatDuration(record.totalDurationToday);
        }
        return record;
      });
    }

    if (this.data.service === 'userAttendenceReportService') {
      downLoadData = (downLoadData || []).map(record => {
        if (record) {
          const parseTimeToSeconds = (timeStr: any): number => {
            if (timeStr === null || timeStr === undefined || timeStr === '' || timeStr === '--') return 0;
            if (typeof timeStr === 'string' && timeStr.includes(':')) {
              const parts = timeStr.split(':');
              return ((parseInt(parts[0], 10) || 0) * 3600) + ((parseInt(parts[1], 10) || 0) * 60) + (parseInt(parts[2], 10) || 0);
            }
            const n = parseFloat(timeStr);
            return isNaN(n) || n < 0 ? 0 : n;
          };

          const onlineSec = parseTimeToSeconds(record.onlineTotalDuration);
          const breakSec = parseTimeToSeconds(record.breakTotalDuration);
          const offlineSec = parseTimeToSeconds(record.offlineTotalDuration);
          let totalSec = onlineSec + breakSec + offlineSec;

          if (totalSec === 0 && record.totalDuration) {
            totalSec = parseTimeToSeconds(record.totalDuration);
          }
          if (totalSec === 0 && record['SUM(totalDuration)']) {
            totalSec = parseTimeToSeconds(record['SUM(totalDuration)']);
          }

          const hours = Math.floor(totalSec / 3600);
          const minutes = Math.floor((totalSec % 3600) / 60);
          const seconds = Math.floor(totalSec % 60);

          const formattedTotal = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

          record.totalDuration = formattedTotal;
          record['Total Duration Sum'] = formattedTotal;
          if (record['SUM(totalDuration)'] !== undefined) {
            record['SUM(totalDuration)'] = formattedTotal;
          }
        }
        return record;
      });
    }

    if (this.data.service === 'purchaseOrderService' || this.data.service === 'posPurchaseService') {
      const flattenedList: any[] = [];
      (downLoadData || []).forEach((po: any) => {
        if (!po) return;

        let resolvedWarehouse = po.warehouseName;
        if (!resolvedWarehouse && po.warehouseId && this.warehouseList && this.warehouseList.length > 0) {
          const foundWh = this.warehouseList.find((w: any) => w.id == po.warehouseId || w.warehouseId == po.warehouseId);
          if (foundWh) {
            resolvedWarehouse = foundWh.name || foundWh.warehouseName;
          }
        }

        const items = po.purchasesItems || po.purchasesOrderItems || po.purchaseItems;
        if (Array.isArray(items) && items.length > 0) {
          items.forEach((item: any) => {
            let resolvedTaxRateName = item.taxRateName;
            if (!resolvedTaxRateName && item.taxRateId && this.taxRateList && this.taxRateList.length > 0) {
              const foundTax = this.taxRateList.find((t: any) => t.id == item.taxRateId || t.taxRateId == item.taxRateId);
              if (foundTax) {
                resolvedTaxRateName = foundTax.name || foundTax.taxName || (foundTax.rate !== undefined ? `${foundTax.rate}%` : '');
              }
            }
            if (!resolvedTaxRateName) {
              resolvedTaxRateName = item.tax !== undefined && item.tax !== null ? item.tax : '';
            }

            let formattedExpiry = item.expiry || item.expiryDate || '';
            if (formattedExpiry && formattedExpiry !== "01-Jan-1970 05:30:00") {
              try {
                formattedExpiry = this.datepipe.transform(formattedExpiry, 'yyyy-MM-dd') || formattedExpiry;
              } catch (e) { }
            } else if (formattedExpiry === "01-Jan-1970 05:30:00") {
              formattedExpiry = '';
            }

            flattenedList.push({
              ...po,
              warehouseName: resolvedWarehouse || po.warehouseName || '',
              productCode: item.sku || item.productCode || item.code || '',
              productName: item.productName || item.name || '',
              sku: item.sku || item.productCode || item.code || '',
              netUnitCost: item.netUnitCost !== undefined && item.netUnitCost !== null && item.netUnitCost !== '' ? item.netUnitCost : (item.unitCost !== undefined ? item.unitCost : (item.cost !== undefined ? item.cost : '')),
              quantity: item.quantity !== undefined && item.quantity !== null ? item.quantity : (item.unitQuantity !== undefined ? item.unitQuantity : ''),
              taxRateId: item.taxRateId,
              taxRateName: resolvedTaxRateName,
              tax: resolvedTaxRateName,
              discount: item.discount !== undefined && item.discount !== null ? item.discount : (item.itemDiscount !== undefined ? item.itemDiscount : 0),
              expiry: formattedExpiry,
              expiryDate: formattedExpiry,
            });
          });
        } else {
          flattenedList.push({
            ...po,
            warehouseName: resolvedWarehouse || po.warehouseName || '',
            productCode: '',
            productName: '',
            sku: '',
            netUnitCost: '',
            quantity: '',
            taxRateId: '',
            taxRateName: '',
            tax: '',
            discount: '',
            expiry: '',
            expiryDate: '',
          });
        }
      });
      downLoadData = flattenedList;
    }

    if (this.colummnToBeRemoved && Array.isArray(this.colummnToBeRemoved) && this.colummnToBeRemoved.length > 0) {
      downLoadData = this.removeColumn(downLoadData)
    }

    // NEW: Dynamic groupBy Excel export
    if (this.data?.dynamicGroupByConfig?.enabled === true) {
      this.downloadDynamicGroupByExcel(downLoadData);
      return;
    }

    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    let jsonHeaderKeys: string[] = [];
    let headerAOA = this.header;
    if (headerAOA && Array.isArray(headerAOA) && headerAOA.length > 0 && !Array.isArray(headerAOA[0])) {
      headerAOA = [headerAOA];
    }

    // NEW DYNAMIC HEADER FALLBACK: For Solr modules, if the backend provides keys that 
    // don't map to the hardcoded `headerAOA` (e.g., custom Deal fields like 'Amount', 'Deal Name'),
    // we should dynamically build the headers from the response itself to prevent an empty Excel sheet.
    const isSolrWrapped = (currentUrl === '/lead' || currentUrl === '/companies' || currentUrl === '/deals' || currentUrl === '/contact' || currentUrl === '/contacts' || currentUrl.includes('contact'));
    if (isSolrWrapped && downLoadData && downLoadData.length > 0) {
      if (currentUrl === '/deals') {
        const canonicalHeaderMap: { [canonical: string]: string } = {
          'deals name': 'Deal Name',
          'deal name': 'Deal Name',
          'deal_name': 'Deal Name',
          'deals_name': 'Deal Name',
          'company name': 'Company',
          'company': 'Company',
          'company_name': 'Company',
          'deal value': 'Amount',
          'amount': 'Amount',
          'deal_value': 'Amount',
          'deal stage': 'Stage',
          'stage': 'Stage',
          'stage name': 'Stage',
          'status name': 'Stage',
          'excepted closing date': 'Expected Closing Date',
          'expected closing date': 'Expected Closing Date',
          'sales owner': 'Sales Owner',
          'owner': 'Sales Owner',
          'deals owner': 'Sales Owner',
          'lead name': 'Lead Name',
          'contact name': 'Lead Name'
        };

        const uniqueHeaders: string[] = [];
        const seenNormalized = new Set<string>();

        downLoadData.forEach(row => {
          if (!row) return;
          Object.keys(row).forEach(key => {
            if (key === '_rawRecord') return;
            const lowerKey = String(key || '').trim().toLowerCase();
            const canonical = canonicalHeaderMap[lowerKey] || key;
            const norm = canonical.toLowerCase().replace(/[_-\s]/g, '');
            if (!seenNormalized.has(norm)) {
              seenNormalized.add(norm);
              uniqueHeaders.push(canonical);
            }
          });
        });

        const priorityHeaders = ['Deal Name', 'Company', 'Stage', 'Amount', 'Paid', 'Balance', 'Sales Owner', 'Lead Name', 'Created Date', 'Updated Date', 'Closing Date', 'Expected Closing Date', 'Description'];
        const finalHeaders: string[] = [];
        const finalSeen = new Set<string>();

        priorityHeaders.forEach(h => {
          const norm = h.toLowerCase().replace(/[_-\s]/g, '');
          if (seenNormalized.has(norm) || h === 'Deal Name' || h === 'Company' || h === 'Stage' || h === 'Amount') {
            finalHeaders.push(h);
            finalSeen.add(norm);
          }
        });

        uniqueHeaders.forEach(h => {
          const norm = h.toLowerCase().replace(/[_-\s]/g, '');
          if (!finalSeen.has(norm)) {
            finalHeaders.push(h);
            finalSeen.add(norm);
          }
        });

        headerAOA = [finalHeaders];
        this.useDefaultHeading = true;
      } else {
        const firstRowKeys = Object.keys(downLoadData[0]).filter(k => k !== '_rawRecord');
        if (firstRowKeys.length > 0 && (!headerAOA || headerAOA.length === 0)) {
          headerAOA = [firstRowKeys];
          this.useDefaultHeading = true;
        }
      }
    }

    const hasExplicitHeader = headerAOA && headerAOA.length > 0 && Array.isArray(headerAOA[0]) && headerAOA[0].length > 0;
    let headerNames: string[] = [];
    if (hasExplicitHeader) {
      this.useDefaultHeading = true;
      headerNames = [...headerAOA[0]];
    } else if (this.columns && this.columns.length > 0) {
      const visibleCols = this.columns.filter(c => c && c.visible && c.property !== 'actions');
      headerNames = visibleCols.length > 0 ? visibleCols.map(c => c.name || c.property) : [];
      if (headerNames.length > 0) {
        this.useDefaultHeading = true;
      }
    } else if (downLoadData && downLoadData.length > 0) {
      headerNames = Object.keys(downLoadData[0]).filter(k => k !== '_rawRecord');
      if (headerNames.length > 0) {
        this.useDefaultHeading = true;
      }
    }

    if (headerNames.length > 0) {
      this.useDefaultHeading = true;

      const seenNormalized = new Set<string>();
      headerNames.forEach(h => {
        const norm = String(h || '').trim().toLowerCase().replace(/[_-\s]/g, '');
        if (norm) seenNormalized.add(norm);
      });

      if (this.columns) {
        this.columns.forEach(col => {
          if (col && col.property) {
            const normProp = String(col.property || '').trim().toLowerCase().replace(/[_-\s]/g, '');
            if (normProp) seenNormalized.add(normProp);
          }
        });
      }

      const synonymMap: { [alias: string]: string } = {
        'leadsource': 'sourcename',
        'leadstatus': 'statusname',
        'phonenumber': 'phonenumber',
        'phoneno': 'phonenumber',
        'owneremail': 'owneremail',
        'ownerfirstname': 'owner',
        'createddate': 'createddate',
        'updateddate': 'updateddate',
        'leadid': 'entityid',
      };
      Object.keys(synonymMap).forEach(k => {
        if (seenNormalized.has(k) || seenNormalized.has(synonymMap[k])) {
          seenNormalized.add(k);
          seenNormalized.add(synonymMap[k]);
        }
      });

      const defaultRemoved = ['leadid', 'lead_id', 'lead id', 'document', 'ownerfirstname', 'owner_firstname', 'ownerid', 'owner_id'];
      const customRemoved = (this.colummnToBeRemoved || [])
        .map((col: string) => String(col).trim().toLowerCase().replace(/[_-\s]/g, ''));
      const removedSet = new Set<string>([...defaultRemoved, ...customRemoved]);

      headerNames = headerNames.filter(h => {
        const normH = String(h || '').trim().toLowerCase().replace(/[_-\s]/g, '');
        return !removedSet.has(normH);
      });

      if (!hasExplicitHeader) {
        (downLoadData || []).forEach(row => {
          if (!row) return;
          Object.keys(row).forEach(k => {
            if (k === '_rawRecord') return;
            const normKey = String(k || '').trim().toLowerCase().replace(/[_-\s]/g, '');
            const mappedSyn = synonymMap[normKey] || normKey;
            const isRemoved = removedSet.has(normKey) || removedSet.has(mappedSyn);
            if (!isRemoved && !seenNormalized.has(normKey) && !seenNormalized.has(mappedSyn)) {
              seenNormalized.add(normKey);
              seenNormalized.add(mappedSyn);
              headerNames.push(k);
            }
          });
        });
      }

      const defaultMapping = {
        'Reference No': 'referenceNo',
        'Location': 'warehouseName',
        'Date': 'date',
        'Supplier': 'supplier',
        'Grand Total': 'grandTotal',
        'Balance': 'balance',
        'Paid': 'paid',
        'Purchase Status': 'status',
        'Payment Status': 'paymentStatus',
        'Product Code': 'productCode',
        'Product code': 'productCode',
        'Net Unit Cost': 'netUnitCost',
        'Quantity': 'quantity',
        'Tax Rate Name': 'taxRateName',
        'Tax Rate': 'taxRateName',
        'Discount': 'discount',
        'Expiry Date': 'expiry',
        'Expiry': 'expiry',
        'Stage Name': 'statusName',
        'Stage': 'statusName',
        'Deal Stage': 'statusName',
        'Amount': 'amount',
        'Closing Date': 'closingDate',
        'Created Date': 'createdDate',
        'created Date': 'createdDate',
        'createdDate': 'createdDate',
        'Updated Date': 'updatedDate',
        'updated Date': 'updatedDate',
        'updatedDate': 'updatedDate',
        'Name': 'name',
        'Property Name': 'propertyName',
        'propertyName': 'propertyName',
        'Email': 'email',
        'Phone No': 'phoneNumber',
        'Phone': 'phoneNumber',
        'Secondary Phone No': 'secondaryphoneno',
        'Secondaryphoneno': 'secondaryphoneno',
        'Status Name': 'statusName',
        'Source Name': 'sourceName',
        'Owner': 'ownerEmail',
        'owner': 'ownerEmail',
        'Description': 'description',
        'Total Activity Count': 'count',
        'Activity Count': 'count',
        'Country': 'country',
        'City': 'city',
        'State': 'state',
        'Campaign Name': 'campaignName',
        'Ad Name': 'adName',
        'adName': 'adName',
        'Page Url': 'pageUrl',
        'pageUrl': 'pageUrl',
        'page_url': 'pageUrl',
        'Action Type': 'actionType',
        'actionType': 'actionType',
        'action_type': 'actionType',
        'Element Id': 'elementId',
        'elementId': 'elementId',
        'element_id': 'elementId',
        'Created At': 'createdAt',
        'createdAt': 'createdAt',
        'created_at': 'createdAt',
        'User': 'createdBy',
        'Check In Time': 'createdAt',
        'Check Out Time': 'updatedAt',
        'Total Duration Sum': 'totalDuration',
      };

      jsonHeaderKeys = headerNames.map(name => {
        const trimmedName = String(name || '').trim();
        const matchedCol = this.columns && this.columns.find(col => String(col.name || '').trim().toLowerCase() === trimmedName.toLowerCase());
        if (matchedCol) {
          return matchedCol.property;
        }

        // Case-insensitive fallback dictionary lookup
        const lowerName = trimmedName.toLowerCase();
        for (const key of Object.keys(defaultMapping)) {
          if (key.toLowerCase() === lowerName) {
            return defaultMapping[key];
          }
        }
        return name;
      });

      const dataRows = (downLoadData || []).map((row: any) => {
        return jsonHeaderKeys.map((key, index) => {
          const origHeader = headerNames[index];
          let val = this.getFieldValue(row, key, origHeader);
          if (key === 'createdAt' || key === 'updatedAt' || (origHeader && (origHeader.toLowerCase().includes('time') || origHeader.toLowerCase().includes('date')) && !origHeader.toLowerCase().includes('duration'))) {
            if (val && typeof val !== 'boolean') {
              const d = new Date(val);
              if (!isNaN(d.getTime())) {
                const formatted = this.datepipe.transform(d, 'dd MMM yyyy, h:mm a');
                if (formatted) val = formatted;
              }
            }
          } else if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)) {
            val = this.datepipe.transform(val, 'dd MMM yyyy, h:mm a');
          }
          return (val !== undefined && val !== null) ? val : '';
        });
      });

      const aoa = [headerNames, ...dataRows];
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(aoa);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let filename = this.downloadFileName + '.xlsx';
      XLSX.writeFile(wb, filename);

      this.dialogRef.close({ event: 'close', data: 'sd' });
      this.resetFilters();
      this.downloadDataComplete = 'OK';
      return;
    } else {
      const jsonOpts: any = {};
      if (jsonHeaderKeys.length > 0) {
        jsonOpts.header = jsonHeaderKeys;
        downLoadData = downLoadData.map(row => {
          const filteredRow: any = {};
          jsonHeaderKeys.forEach(key => {
            let val = row[key];
            if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)) {
              filteredRow[key] = this.datepipe.transform(val, 'dd MMM yyyy, h:mm a');
            } else {
              filteredRow[key] = val;
            }
          });
          return filteredRow;
        });
      }
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(downLoadData, jsonOpts);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let filename = this.downloadFileName + '.xlsx'
      XLSX.writeFile(wb, filename);
    }

    this.dialogRef.close({ event: 'close', data: 'sd' })

    this.resetFilters();

    this.downloadDataComplete = "OK";
  }


  removeColumn(downloadData) {

    this.downloadData = downloadData.map(obj => {
      for (const column of this.colummnToBeRemoved) {
        delete obj[column];
      }
      return obj;
    });


    return this.downloadData;

  }

  // NEW: Dynamic groupBy Excel export
  private downloadDynamicGroupByExcel(downLoadData: any[]): void {
    const config = this.data?.dynamicGroupByConfig || {};
    const fixedColumn = config.fixedColumn;
    const fixedColumnHeader = config.fixedColumnHeader || fixedColumn;
    const excludedKeys = new Set<string>(config.excludedKeys || []);

    if (fixedColumn) {
      excludedKeys.add(fixedColumn);
    }

    const dynamicKeys: string[] = [];

    (downLoadData || []).forEach(row => {
      if (!row) {
        return;
      }
      Object.keys(row).forEach(key => {
        if (
          key !== fixedColumn &&
          !excludedKeys.has(key) &&
          dynamicKeys.indexOf(key) === -1
        ) {
          dynamicKeys.push(key);
        }
      });
    });

    const exportKeys: string[] = [];
    const exportHeaders: string[] = [];

    if (fixedColumn) {
      exportKeys.push(fixedColumn);
      exportHeaders.push(fixedColumnHeader);
    }

    exportKeys.push(...dynamicKeys);
    exportHeaders.push(...dynamicKeys);

    const normalizedData = (downLoadData || [])
      .filter(row => !!row)
      .map(row => {
        const normalizedRow: any = {};
        exportKeys.forEach(key => {
          const value = row[key];
          if (key === fixedColumn) {
            normalizedRow[key] = value === null || value === undefined ? '' : value;
          } else {
            normalizedRow[key] = value === null || value === undefined ? 0 : value;
          }
        });
        return normalizedRow;
      });

    if (normalizedData.length > 0) {
      const totalRow: any = {};
      exportKeys.forEach(key => {
        if (key === fixedColumn) {
          totalRow[key] = 'TOTAL';
        } else {
          totalRow[key] = normalizedData.reduce((sum, row) => sum + (Number(row[key]) || 0), 0);
        }
      });
      normalizedData.push(totalRow);
    }

    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    XLSX.utils.sheet_add_aoa(ws, [exportHeaders], { origin: 'A1' });
    XLSX.utils.sheet_add_json(ws, normalizedData, {
      origin: 'A2',
      skipHeader: true,
      header: exportKeys
    });

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const filename = this.downloadFileName + '.xlsx';
    XLSX.writeFile(wb, filename);

    if (this.dialogRef) {
      this.dialogRef.close({ event: 'close', data: 'sd' });
    }
    this.resetFilters();
    this.downloadDataComplete = "OK";
  }

  //lead status

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
      },
      error => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(user => user['name'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
      },
      error => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }

  filterColumnMultiSelect(value, index, j) {
    if (value && value.value && value.value.length > 0) {
      this[this.filterSelectObj[index].position] = value.value.join(',');
    } else {
      this[this.filterSelectObj[index].position] = undefined;
    }

    console.log(this.selectedValues);
    this.filterOutput();
  }

  //user Group

  defaultLeadOwner: FormControl = new FormControl('');

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;
        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }


  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags() {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data;
        this.tagsTypeList = data;
        this.filteredtagsTypeList = this.tagsTypeList;
      },
      error => {
      }
    )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredtagsTypeList = this.filteredtagsTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
  }

  // Industry Type
  industryList: any = [];
  industryTypeList: any = [];
  filteredindustryTypeList: any = [];

  getAllIndustry() {
    this.industryTypeService.getAllIndustryTypeDropDown(6).subscribe(
      data => {
        this.industryList = data;
        this.industryTypeList = data;
        this.filteredindustryTypeList = this.industryTypeList;
      },
      error => {
      }
    )
  }

  // Business Type
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];

  getAllBusiness() {
    this.bussinessTypeService.getAllBusinessDropDown(7).subscribe(
      data => {
        this.BusinessList = data;
        this.BusinessTypeList = data;
        this.filteredBusinessTypeList = this.BusinessTypeList;
      },
      error => {
      }
    )
  }

  //stagr


  getDealStage() {

    this.dealsStageService.getAllDealsStagesDropDown(4).subscribe(
      res => {

        this.dealStatusList = res;
        this.dealStatusTypeList = res;
        this.filteredlDealStatusTypeList = this.dealStatusTypeList;

        console.log(this.dealStatusList);


      },
      error => {
      }
    )
    this.LeadStatusYFilter();
    this.getLeadStatusList();
  }


  //lead status

  dealStatusList: any;
  dealStatusTypeList: any;
  filteredlDealStatusTypeList: any;

  public dealStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.filteredlDealStatusTypeList = this.dealStatusTypeList;
  }

  LeadStatusYFilter() {
    this.dealStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.dealStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.dealStatusFilterControl.value;
    if (!search) {
      this.filteredlDealStatusTypeList = this.dealStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredlDealStatusTypeList = this.dealStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }

  //ActivityType

  filteredActivityTypeList: any;

  LeadActivityTypeList: any;
  LeadActivityList: any;

  getLeadActivityTypeDownList() {

    this.leadSourceService.getAllActivityTypeDropDown().subscribe(
      res => {
        this.LeadActivityList = res;
        this.LeadActivityTypeList = res;
        this.filteredActivityTypeList = this.LeadActivityTypeList;
      },
      error => {
      })
  }


  LeadActivityTypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadActivityTypeYFilter();
      });
  }


  protected typeLeadActivityTypeYFilter() {
    if (!this.LeadActivityTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredActivityTypeList = this.LeadActivityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredActivityTypeList = this.LeadActivityTypeList.filter(source => source['activityType'].toLowerCase().indexOf(search) > -1)
  }

  getAllActivityTypedropdowntype() {
    this.filteredActivityTypeList = this.LeadActivityTypeList;
  }

  //paidBy

  paymentList: any;
  paymentTypeList: any;
  filteredPayemntTypeList: any;

  public paymentFilterControl: UntypedFormControl = new UntypedFormControl();

  getPaymentList() {
    this.paymentTypeService.getAllPaymentModeDropDown().subscribe(
      res => {
        this.paymentList = res;
        this.paymentTypeList = res;
        this.filteredPayemntTypeList = this.paymentTypeList;

      },
      () => {
      })
  }


  PaymentYFilter() {
    this.paymentFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.paymentFilter();
      });
  }


  protected paymentFilter() {
    if (!this.paymentTypeList) {
      return;
    }
    // get the search keyword
    let search = this.paymentFilterControl.value;
    if (!search) {
      this.filteredPayemntTypeList = this.paymentTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPayemntTypeList = this.paymentTypeList.filter(bank => bank['name']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllPaymentSet() {
    this.filteredPayemntTypeList = this.paymentTypeList;
  }


  //warehouse
  warehouseList: any = [];
  warehouseTypeList: any = [];
  filteredWarehouseTypeList: any = [];
  warehouseControl: UntypedFormControl = new UntypedFormControl();
  warehouseFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllWareHouseList() {

    this.poswarehouseService.getAllWarehouseDropDown().subscribe(
      data => {
        this.warehouseList = data;


        // this.warehouseList.push(object);

        this.warehouseTypeList = data;
        this.filteredWarehouseTypeList = this.warehouseTypeList;

      }
    )

    this.warehouseYFilter();
    this.getAllWarehouse();
  }


  getAllWarehouse() {
    this.filteredWarehouseTypeList = this.warehouseTypeList;
  }

  warehouseYFilter() {
    this.warehouseFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.warehouseFilter();
      });
  }

  protected warehouseFilter() {
    if (!this.warehouseTypeList) {
      return;
    }
    // get the search keyword
    let search = this.warehouseFilterControl.value;
    if (!search) {
      this.filteredWarehouseTypeList = this.warehouseTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredWarehouseTypeList = this.warehouseTypeList.filter(Warehouse => Warehouse['name'].toLowerCase().indexOf(search) > -1)
  }

  //tax rate
  taxRateList: any = [];
  taxRateTypeList: any = [];
  filteredTaxRateTypeList: any = [];
  taxRateControl: UntypedFormControl = new UntypedFormControl();
  taxRateFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllTaxRateList() {
    this.postaxRateService.getAllTaxDropDown().subscribe(
      (data: any) => {
        this.taxRateList = data || [];
        this.taxRateTypeList = data || [];
        this.filteredTaxRateTypeList = this.taxRateTypeList;
      },
      error => {
        console.error('Error loading tax rates:', error);
      }
    );
    this.taxRateYFilter();
    this.getAllTaxRates();
  }

  getAllTaxRates() {
    this.filteredTaxRateTypeList = this.taxRateTypeList;
  }

  taxRateYFilter() {
    this.taxRateFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.taxRateFilter();
      });
  }

  protected taxRateFilter() {
    if (!this.taxRateTypeList) {
      return;
    }
    let search = this.taxRateFilterControl.value;
    if (!search) {
      this.filteredTaxRateTypeList = this.taxRateTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTaxRateTypeList = this.taxRateTypeList.filter(tax => (tax['name'] || tax['taxName'] || '').toLowerCase().indexOf(search) > -1);
  }

  //supplier
  supplierList: any = [];
  supplierTypeList: any = [];
  filteredsupplierTypeList: any = [];
  supplierControl: UntypedFormControl = new UntypedFormControl();
  supplierFilterControl: UntypedFormControl = new UntypedFormControl();
  options: any;


  getAllSupplierList() {

    this.posSupplierService.getAllsupplierDropDown().subscribe(
      data => {
        this.supplierList = data;

        this.supplierTypeList = data;
        this.filteredsupplierTypeList = this.supplierTypeList;

      }
    )

    this.supplierYFilter();
    this.getAllsupplier();
  }

  getAllsupplier() {
    this.filteredsupplierTypeList = this.supplierTypeList;
  }

  supplierYFilter() {
    this.supplierFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.supplierFilter();
      });
  }

  protected supplierFilter() {
    if (!this.supplierTypeList) {
      return;
    }
    // get the search keyword
    let search = this.supplierFilterControl.value;
    if (!search) {
      this.filteredsupplierTypeList = this.supplierTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredsupplierTypeList = this.supplierTypeList.filter(supplier => supplier['name'].toLowerCase().indexOf(search) > -1)
  }


  async downloadAll(res: any, sortParam: any) {

    const requestedTotal = +(this.firstFormGroup.value.size || 10); // 2500 / 10000 / 20000
    const maxPageSize = 2000;

    this.downloadData = [...(res.content || [])];

    const totalAvailable = res.totalElements != null
      ? +res.totalElements
      : this.downloadData.length;

    const targetTotal = Math.min(requestedTotal, totalAvailable);

    // already enough
    if (this.downloadData.length >= targetTotal) {
      this.downloadDataFinal(this.downloadData.slice(0, targetTotal));
      return;
    }

    let page = 1;
    const service = this.getService(this.data.service);

    while (this.downloadData.length < targetTotal) {

      const remaining = targetTotal - this.downloadData.length;
      const size = Math.min(maxPageSize, remaining);

      const apiName = this.searchTermPresent ? this.data.url : (this.data.url2 || this.data.url);
      const method = service[apiName];

      const effectiveSearchTerm = this.searchTerm || (this.solrUrl ? '*:*' : null);
      let pageRes: any;
      if (method.length === 6) {
        pageRes = await method.call(service, effectiveSearchTerm, page, size, sortParam, this.groupBy, this.data.additionalQuery).toPromise();
      } else if (method.length === 5) {
        pageRes = await method.call(service, effectiveSearchTerm, page, size, sortParam, this.groupBy).toPromise();
      } else if (method.length === 4) {
        pageRes = await method.call(service, effectiveSearchTerm, page, size, sortParam).toPromise();
      } else {
        pageRes = await method.call(service, page, size, sortParam).toPromise();
      }

      const rows = pageRes?.content || [];
      if (!rows.length) break;

      this.downloadData.push(...rows);
      page++;
    }

    if (this.data.service === 'purchaseOrderService') {
      if (!this.taxRateList || this.taxRateList.length === 0) {
        try {
          const taxRes: any = await this.postaxRateService.getAllTaxDropDown().toPromise();
          this.taxRateList = taxRes || [];
        } catch (e) { }
      }
      if (!this.warehouseList || this.warehouseList.length === 0) {
        try {
          const whRes: any = await this.poswarehouseService.getAllWarehouseDropDown().toPromise();
          this.warehouseList = whRes || [];
        } catch (e) { }
      }
    }

    this.downloadDataFinal(this.downloadData.slice(0, targetTotal));

    console.log('Requested:', requestedTotal);
    console.log('Available:', totalAvailable);
    console.log('Downloaded:', this.downloadData.length);


  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  private initializeServicesMap(): void {
    this.servicesMap = new Map<string, any>([
      ['productService', this.productService],
      ['leadStatusService', this.leadStatusService],
      ['leadSourceService', this.leadSourceService],
      ['usersService', this.usersService],
      ['groupByReportService', this.groupByReportService],
      ['followActivityReportService', this.followActivityReportService],
      ['leadCallReportService', this.leadCallReportService],
      ['leadCallWithOutGroupByReportService', this.leadCallWithOutGroupByReportService],
      ['leadFormIdReportService', this.leadFormIdReportService],
      ['leadUserFormIdReportService', this.leadUserFormIdReportService],
      ['clientUserActivityReportService', this.clientUserActivityReportService],
      ['activityService', this.activityService],
      ['housingBuilderService', this.housingBuilderService],
      ['supplierService', this.supplierService],
      ['dealsService', this.dealsService],
      ['contactsService', this.contactsService],
      ['patientService', this.patientService],
      ['taskService', this.taskService],
      ['courseReportsService', this.courseReportsService],
      ['courseItemHistoryReportService', this.courseItemHistoryReportService],
      ['coursehistoryreportService', this.coursehistoryreportService],
      ['userAttendenceReportService', this.userAttendenceReportService],
      ['userService', this.userService],
      ['dialerReportService', this.dialerReportService],
      ['dialersReportService', this.dialersReportService],
      ['dialerTotalDurationByUserReportService', this.dialerTotalDurationByUserReportService],
      ['supplierCommisionReportService', this.supplierCommisionReportService],
      ['vendorWiseQtyReportService', this.vendorWiseQtyReportService],
      ['supplierPaymentReportService', this.supplierPaymentReportService],
      ['catalogSearchReportService', this.catalogSearchReportService],
      ['salesByProductVariantSkuService', this.salesByProductVariantSkuService],
      ['taxReportService', this.taxReportService],
      ['transactionHistoryReportService', this.transactionHistoryReportService],
      ['overAllDiscountCouponReportService', this.overAllDiscountCouponReportService],
      ['individualCustomerReportService', this.individualCustomerReportService],
      ['userCouponReportService', this.userCouponReportService],
      ['hrmLocationService', this.hrmLocationService],
      ['hrmDepartmentService', this.hrmDepartmentService],
      ['leadproductwisereportService', this.leadproductwisereportService],
      ['loanpendinglistreportService', this.loanpendinglistreportService],
      ['duplicateLeadService', this.duplicateLeadService],
      ['goldLoanActiveListReportService', this.goldLoanActiveListReportService],
      ['goldloancompletedlistService', this.goldloancompletedlistService],
      ['goldActivityService', this.goldActivityService],
      ['mlmUserreportService', this.mlmUserreportService],
      ['mlmOrderreportService', this.mlmOrderreportService],
      ['kitchenMosterService', this.kitchenMosterService],
      ['suspensCategoriesService', this.suspensCategoriesService],
      ['expenseCategoryService', this.expenseCategoryService],
      ['unitsService', this.unitsService],
      ['sourceService', this.sourceService],
      ['brandService', this.brandService],
      ['poscurriencesService', this.poscurriencesService],
      ['purchaseOrderService', this.purchaseOrderService],
      ['giftcardsService', this.giftcardsService],
      ['saleOrderService', this.saleOrderService],
      ['diningtablesService', this.diningtablesService],
      ['posPurchaseService', this.posPurchaseService],
      ['goodsreceivedService', this.goodsreceivedService],
      ['categoriesService', this.categoriesService],
      ['poswarehouseService', this.poswarehouseService],
      ['posproductService', this.posproductService],
      ['postaxRateService', this.postaxRateService],
      ['posSupplierService', this.posSupplierService],
      ['quantityAdjustmentsService', this.quantityAdjustmentsService],
      ['expensesService', this.expensesService],
      ['posSalesService', this.posSalesService],
      ['quotationService', this.quotationService],
      ['transfersService', this.transfersService],
      ['salesReturnService', this.salesReturnService],
      ['supplierReportService', this.supplierReportService],
      ['supplierProductsReportService', this.supplierProductsReportService],
      ['registerReportService', this.registerReportService],
      ['productsReportService', this.productsReportService],
      ['adjustmentsReportService', this.adjustmentsReportService],
      ['categoriesReportService', this.categoriesReportService],
      ['brandsReportService', this.brandsReportService],
      ['profitByProductReportService', this.profitByProductReportService],
      ['warehouseTransactionsReportService', this.warehouseTransactionsReportService],
      ['deletedentriesreportsService', this.deletedentriesreportsService],
      ['bankTransactionReportService', this.bankTransactionReportService],
      ['paymentsReportService', this.paymentsReportService],
      ['taxRateReportService', this.taxRateReportService],
      ['posExpenseReportService', this.posExpenseReportService],
      ['purchasesReportService', this.purchasesReportService],
      ['productQuantityAlertsService', this.productQuantityAlertsService],
      ['leadScoringReportService', this.leadScoringReportService],
      ['leadIdByLeadScoreReportService', this.leadIdByLeadScoreReportService],
      ['refferalCommissionReportService', this.refferalCommissionReportService],
      ['staffReportService', this.staffReportService],
      ['googleCalendarReportService', this.googleCalendarReportService],
      ['callStageProductivityPendingAndFollowService', this.callStageProductivityPendingAndFollowService],
      ['registrationService', this.registrationService],
      ['usercallreportService', this.usercallreportService],
      ['leadUserSourceStatusReportService', this.leadUserSourceStatusReportService],
      ['dealsGroupWiseReportService', this.dealsGroupWiseReportService],
      ['delasUserWiseReportService', this.delasUserWiseReportService],
      ['statusService', this.statusService],
      ['leadOwnerService', this.leadOwnerService],
      ['productQtyAndExpiryAlertsReportService', this.productQtyAndExpiryAlertsReportService],
      ['customersreportService', this.customersreportService],
      ['productExpiryAlertsService', this.productExpiryAlertsService],
      ['salesReportService', this.salesReportService],
      ['distributorAnalysisService', this.distributorAnalysisService],
      ['leadCallOverViewReportService', this.leadCallOverViewReportService],
      ['posCustomersReportService', this.posCustomersReportService],
      ['hrmDailyUserTimeSummaryReportService', this.hrmDailyUserTimeSummaryReportService],
      ['hrmProjectStatusReportService', this.hrmProjectStatusReportService],
      ['whatsappContactService', this.whatsappContactService],
      ['projectsService', this.projectsService],
      ['whatsAppCampaignService', this.whatsAppCampaignService],
      ['leadStatusOverAllReportService', this.leadStatusOverAllReportService],
      ['tasksByOwnerReportService', this.tasksByOwnerReportService],
      ['closedReportByLeadSourceService', this.closedReportByLeadSourceService],
      ['tagesStatusService', this.tagesStatusService],
      ['botRepliesService', this.botRepliesService],
      ['whatsappMessageLogsReportService', this.whatsappMessageLogsReportService],
      ['whatsappTemplateService', this.whatsappTemplateService],
      ['whatsAppContactGroupService', this.whatsAppContactGroupService],
      ['callConnectionSummaryService', this.callConnectionSummaryService],
      ['customerOrderReportService', this.customerOrderReportService],
      ['chatContactsService', this.chatContactsService],
      ['salesTargetReportService', this.salesTargetReportService],
      ['chatBotRepliesService', this.chatBotRepliesService],
      ['sequenceActivityGroupByReportService', this.sequenceActivityGroupByReportService],
      ['companiesService', this.companiesService],
      ['sourceStatusService', this.sourceStatusService],
      ['clientActivityReportService', this.clientActivityReportService],
      ['leadsAndDealsWithCalenderReportService', this.leadsAndDealsWithCalenderReportService],
      ['meetingSummaryForLeadsAndDealsReportService', this.meetingSummaryForLeadsAndDealsReportService],
      ['dealsStageService', this.dealsStageService],
      ['leadTaskReportService', this.leadTaskReportService],
      ['paymentTypeService', this.paymentTypeService],
      ['userDeviceActivityReportService', this.userDeviceActivityReportService],
      ['taskReportService', this.taskReportService],
      ['industryTypeService', this.industryTypeService],
      ['bussinessTypeService', this.bussinessTypeService],
      ['todayLeadScoringReportService', this.todayLeadScoringReportService],
      ['userWebActivityReportService', this.userWebActivityReportService],
      ['userWebActivityClientReportService', this.userWebActivityClientReportService],
      ['upcomingAccountRenewalService', this.upcomingAccountRenewalService],
      ['botFlowsService', this.botFlowsService],
      ['whatsappMessageLogsService', this.whatsappMessageLogsService],
      ['chatBotFlowsService', this.chatBotFlowsService],
      ['googleCalendarServiceAccountService', this.googleCalendarServiceAccountService],
      ['salesCallHistorySummaryReportService', this.salesCallHistorySummaryReportService],
      ['propertyService', this.propertyService],
      ['followActivityReportService', this.followActivityReportService],
    ]);
  }

  private getService(serviceName: string): any {
    const service = this.servicesMap.get(serviceName);
    if (!service) {
      console.error(`Service "${serviceName}" not found in servicesMap.`);
      return this[serviceName];
    }
    return service;
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  getFieldValue(row: any, key: string, origHeader?: string): any {
    if (!row) return '';

    const isOwnerGroupKey = (key && key.toLowerCase().includes('owner')) || (origHeader && origHeader.toLowerCase().includes('owner'));
    if (isOwnerGroupKey && row._rawRecord) {
      const raw = row._rawRecord;
      if (raw.dealsName !== undefined || raw.dealName !== undefined || raw.dealsOwner !== undefined) {
        if (raw.dealsOwner !== undefined && raw.dealsOwner !== null && raw.dealsOwner !== '') {
          return raw.dealsOwner;
        }
        const val = row[key] || (origHeader ? row[origHeader] : '');
        const dealNameVal = raw.dealsName || raw.dealName || row['Deal Name'] || row['Deals Name'];
        if (val && dealNameVal && String(val).trim().toLowerCase() === String(dealNameVal).trim().toLowerCase()) {
          return '';
        }
        if (val) return val;
        if (raw.ownerEmail && raw.ownerEmail !== dealNameVal) return raw.ownerEmail;
        if (raw.ownerName && raw.ownerName !== dealNameVal) return raw.ownerName;
        return '';
      }
    }

    // Direct key match
    if (row[key] !== undefined && row[key] !== null && row[key] !== '') return row[key];
    if (origHeader && row[origHeader] !== undefined && row[origHeader] !== null && row[origHeader] !== '') return row[origHeader];

    const aliasGroups: { [groupName: string]: string[] } = {
      productCode: ['product code', 'productcode', 'product_code', 'sku', 'product code / sku'],
      netUnitCost: ['net unit cost', 'netunitcost', 'net_unit_cost', 'unit cost', 'unitcost', 'unit_cost', 'cost'],
      quantity: ['quantity', 'qty', 'unit quantity', 'unitquantity'],
      taxRateName: ['tax rate name', 'taxratename', 'tax_rate_name', 'tax rate', 'taxrate', 'tax_rate', 'tax'],
      discount: ['discount', 'item discount', 'itemdiscount', 'item_discount'],
      expiry: ['expiry date', 'expirydate', 'expiry_date', 'expiry', 'exp date', 'expdate', 'exp_date'],
      referenceNo: ['reference no', 'reference_no', 'referenceno', 'order no', 'purchase order no'],
      warehouseName: ['warehouse name', 'warehousename', 'warehouse_name', 'location', 'warehouse'],
      dealName: ['deal name', 'deals name', 'deal_name', 'deals_name', 'dealname', 'dealsname'],
      company: ['company', 'company name', 'company_name', 'companyname', 'account name', 'account_name', 'accountname'],
      amount: ['amount', 'deal value', 'deal_value', 'dealvalue', 'amount_value', 'amountvalue', 'grand total', 'grandtotal'],
      stage: ['stage', 'deal stage', 'stage name', 'deal_stage', 'stage_name', 'dealstage', 'stagename', 'statusname', 'status_name', 'status name', 'lead status', 'lead_status', 'leadstatus', 'purchase status', 'payment status'],
      source: ['source name', 'source_name', 'sourcename', 'lead source', 'lead_source', 'leadsource', 'source', 'leadsource_name', 'supplier'],
      owner: ['sales owner', 'owner', 'deals owner', 'owner name', 'sales_owner', 'deals_owner', 'salesowner', 'dealsowner', 'owneremail', 'owner_email', 'owner email', 'owner id name', 'owneridname', 'ownerfirstname', 'owner first name', 'owner_first_name'],
      phone: ['phone number', 'phone no', 'phone_number', 'phonenumber', 'phoneno', 'phone', 'mobile'],
      secondaryPhone: ['secondary phone no', 'secondaryphoneno', 'secondary_phone_no', 'secondaryphone', 'secondary phone', 'secondary mobile'],
      closingDate: ['closing date', 'closing_date', 'closingdate'],
      expectedClosingDate: ['expected closing date', 'excepted closing date', 'expected_closing_date', 'excepted_closing_date', 'expectedclosingdate', 'exceptedclosingdate'],
      paid: ['paid'],
      balance: ['balance'],
      productName: ['product name', 'productname', 'product_name', 'product', 'item_name', 'itemname'],
      leadName: ['lead name', 'contact name', 'lead_name', 'contact_name', 'leadname', 'contactname', 'name'],
      description: ['description'],
      activityCount: ['activity count', 'activity_count', 'activitycount', 'total activity count', 'totalactivitycount', 'activitycountonlead'],
      country: ['country', 'country name', 'country_name', 'countryname'],
      city: ['city', 'city name', 'city_name', 'cityname'],
      state: ['state', 'state name', 'state_name', 'statename'],
      campaignName: ['campaign name', 'campaign_name', 'campaignname', 'ad group name', 'ad_group_name', 'adgroupname', 'source campaign'],
      adName: ['ad name', 'ad_name', 'adname', 'form name', 'form_name', 'formname'],
      createdDate: ['created date', 'createddate', 'created_date', 'date'],
      updatedDate: ['updated date', 'updateddate', 'updated_date'],
      renewalDate: ['renewal date', 'renewaldate', 'renewal_date'],
      reasonForLoss: ['reason for lost', 'reason for loss', 'reasonforloss', 'lostreason', 'reason_for_loss'],
      email: ['email', 'email address', 'emailaddress', 'email_address', 'primary email', 'primaryemail'],
      createdBy: ['user', 'created by', 'createdby', 'user_name', 'username', 'user name', 'created_by'],
      createdAt: ['check in time', 'checkintime', 'check_in_time', 'created at', 'createdat', 'created_at', 'clockintime', 'clock_in_time', 'clock in time'],
      updatedAt: ['check out time', 'checkouttime', 'check_out_time', 'updated at', 'updatedat', 'updated_at', 'clockouttime', 'clock_out_time', 'clock out time'],
      totalDuration: ['total duration sum', 'totaldurationsum', 'total_duration_sum', 'total duration', 'totalduration', 'sum(totalduration)', 'total_duration']
    };

    const normKey = String(key || '').toLowerCase().replace(/[_-\s]/g, '');
    const normOrig = origHeader ? String(origHeader || '').toLowerCase().replace(/[_-\s]/g, '') : '';

    let targetGroupKeys: string[] = [];
    let matchedGroupName: string = '';
    for (const gName of Object.keys(aliasGroups)) {
      const groupList = aliasGroups[gName];
      const match = groupList.some(alias => {
        const normAlias = alias.replace(/[_-\s]/g, '');
        return normAlias === normKey || normAlias === normOrig;
      });
      if (match) {
        targetGroupKeys = groupList;
        matchedGroupName = gName;
        break;
      }
    }

    if (targetGroupKeys.length === 0) {
      targetGroupKeys = [normKey];
      if (normOrig) targetGroupKeys.push(normOrig);
    }

    // Search row keys for matching normalized alias
    for (const rKey of Object.keys(row)) {
      if (rKey === '_rawRecord') continue;
      const normRKey = String(rKey).toLowerCase().replace(/[_-\s]/g, '');
      const isMatch = targetGroupKeys.some(alias => alias.replace(/[_-\s]/g, '') === normRKey);
      if (isMatch && row[rKey] !== undefined && row[rKey] !== null && row[rKey] !== '') {
        return row[rKey];
      }
    }

    // Fallback to _rawRecord properties if present
    if (row._rawRecord) {
      const raw = row._rawRecord;

      if (matchedGroupName === 'productName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('product')))) {
        if (raw.productName !== undefined && raw.productName !== null && raw.productName !== '') return raw.productName;
        if (raw.product !== undefined && raw.product !== null && raw.product !== '') return raw.product;
        if (raw.values?.['Product Name'] !== undefined && raw.values?.['Product Name'] !== null && raw.values?.['Product Name'] !== '') return raw.values['Product Name'];
        if (raw.values?.['Product'] !== undefined && raw.values?.['Product'] !== null && raw.values?.['Product'] !== '') return raw.values['Product'];
        return '';
      }

      if (matchedGroupName === 'email' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('email') && !a.includes('owner')))) {
        if (raw.email !== undefined && raw.email !== null && raw.email !== '') return raw.email;
        if (raw.values?.['Email'] !== undefined && raw.values?.['Email'] !== null && raw.values?.['Email'] !== '') return raw.values['Email'];
        return '';
      }

      if (matchedGroupName === 'owner' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('owner')))) {
        if (raw.dealsOwner !== undefined && raw.dealsOwner !== null && raw.dealsOwner !== '') return raw.dealsOwner;
        if (raw.ownerEmail !== undefined && raw.ownerEmail !== null && raw.ownerEmail !== '') return raw.ownerEmail;
        if (raw.ownerName !== undefined && raw.ownerName !== null && raw.ownerName !== '') return raw.ownerName;
        if (raw.ownerIdName !== undefined && raw.ownerIdName !== null && raw.ownerIdName !== '') return raw.ownerIdName;
        if (raw.createdBy !== undefined && raw.createdBy !== null && raw.createdBy !== '') return raw.createdBy;
        return '';
      }

      if (matchedGroupName === 'activityCount' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('activity')))) {
        if (raw.activityCountOnLead !== undefined && raw.activityCountOnLead !== null && raw.activityCountOnLead !== '') return raw.activityCountOnLead;
        if (raw.count !== undefined && raw.count !== null && raw.count !== '') return raw.count;
        if (raw.activityCount !== undefined && raw.activityCount !== null && raw.activityCount !== '') return raw.activityCount;
        return '';
      }

      if (matchedGroupName === 'country' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('country')))) {
        if (raw.country !== undefined && raw.country !== null && raw.country !== '') return raw.country;
        if (raw.values?.['Country'] !== undefined && raw.values?.['Country'] !== null && raw.values?.['Country'] !== '') return raw.values['Country'];
        if (raw.additionalSpec?.['Country'] !== undefined && raw.additionalSpec?.['Country'] !== null && raw.additionalSpec?.['Country'] !== '') return raw.additionalSpec['Country'];
        return '';
      }

      if (matchedGroupName === 'city' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('city')))) {
        if (raw.city !== undefined && raw.city !== null && raw.city !== '') return raw.city;
        if (raw.values?.['City'] !== undefined && raw.values?.['City'] !== null && raw.values?.['City'] !== '') return raw.values['City'];
        return '';
      }

      if (matchedGroupName === 'state' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('state')))) {
        if (raw.state !== undefined && raw.state !== null && raw.state !== '') return raw.state;
        if (raw.values?.['State'] !== undefined && raw.values?.['State'] !== null && raw.values?.['State'] !== '') return raw.values['State'];
        return '';
      }

      if (matchedGroupName === 'campaignName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('campaign')))) {
        if (raw.campaignName !== undefined && raw.campaignName !== null && raw.campaignName !== '') return raw.campaignName;
        if (raw.sourceCampaign !== undefined && raw.sourceCampaign !== null && raw.sourceCampaign !== '') return raw.sourceCampaign;
        if (raw.values?.['Ad Group Name'] !== undefined && raw.values?.['Ad Group Name'] !== null && raw.values?.['Ad Group Name'] !== '') return raw.values['Ad Group Name'];
        return '';
      }

      if (matchedGroupName === 'adName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('ad')))) {
        if (raw.adName !== undefined && raw.adName !== null && raw.adName !== '') return raw.adName;
        if (raw.values?.['Ad Name'] !== undefined && raw.values?.['Ad Name'] !== null && raw.values?.['Ad Name'] !== '') return raw.values['Ad Name'];
        if (raw.formName !== undefined && raw.formName !== null && raw.formName !== '') return raw.formName;
        if (raw.values?.['Form Name'] !== undefined && raw.values?.['Form Name'] !== null && raw.values?.['Form Name'] !== '') return raw.values['Form Name'];
        return '';
      }

      if (matchedGroupName === 'source' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('source')))) {
        if (raw.sourceName !== undefined && raw.sourceName !== null && raw.sourceName !== '') return raw.sourceName;
        if (raw.leadSource !== undefined && raw.leadSource !== null && raw.leadSource !== '') return raw.leadSource;
        if (raw.values?.['Lead Source'] !== undefined && raw.values?.['Lead Source'] !== null && raw.values?.['Lead Source'] !== '') return raw.values['Lead Source'];
        return '';
      }

      if (matchedGroupName === 'stage' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('stage') || a.includes('status')))) {
        if (raw.statusName !== undefined && raw.statusName !== null && raw.statusName !== '') return raw.statusName;
        if (raw.stage !== undefined && raw.stage !== null && raw.stage !== '') return raw.stage;
        return '';
      }

      if (matchedGroupName === 'dealName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('deal')))) {
        if (raw.dealsName !== undefined && raw.dealsName !== null && raw.dealsName !== '') return raw.dealsName;
        if (raw.dealName !== undefined && raw.dealName !== null && raw.dealName !== '') return raw.dealName;
        return '';
      }

      if (matchedGroupName === 'company' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('company') || a.includes('account')))) {
        if (raw.company !== undefined && raw.company !== null && raw.company !== '') return raw.company;
        if (raw.companyName !== undefined && raw.companyName !== null && raw.companyName !== '') return raw.companyName;
        if (raw.values?.['Company'] !== undefined && raw.values?.['Company'] !== null && raw.values?.['Company'] !== '') return raw.values['Company'];
        return '';
      }

      if (matchedGroupName === 'leadName' || (!matchedGroupName && targetGroupKeys.some(a => a === 'leadname' || a === 'contactname' || a === 'lead name' || a === 'contact name'))) {
        if (raw.name !== undefined && raw.name !== null && raw.name !== '') return raw.name;
        if (raw.leadName !== undefined && raw.leadName !== null && raw.leadName !== '') return raw.leadName;
        if (raw.contactName !== undefined && raw.contactName !== null && raw.contactName !== '') return raw.contactName;
        return '';
      }

      if (matchedGroupName === 'phone' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('phone') && !a.includes('secondary')))) {
        if (raw.phoneNumber !== undefined && raw.phoneNumber !== null && raw.phoneNumber !== '') return raw.phoneNumber;
        if (raw.phoneNo !== undefined && raw.phoneNo !== null && raw.phoneNo !== '') return raw.phoneNo;
        if (raw.values?.['Phone Number'] !== undefined && raw.values?.['Phone Number'] !== null && raw.values?.['Phone Number'] !== '') return raw.values['Phone Number'];
        return '';
      }

      if (matchedGroupName === 'secondaryPhone' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('secondary')))) {
        if (raw.secondaryphoneno !== undefined && raw.secondaryphoneno !== null && raw.secondaryphoneno !== '') return raw.secondaryphoneno;
        if (raw.secondaryPhoneNo !== undefined && raw.secondaryPhoneNo !== null && raw.secondaryPhoneNo !== '') return raw.secondaryPhoneNo;
        if (raw.values?.['Secondary Phone No'] !== undefined && raw.values?.['Secondary Phone No'] !== null && raw.values?.['Secondary Phone No'] !== '') return raw.values['Secondary Phone No'];
        return '';
      }

      if (matchedGroupName === 'description' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('description')))) {
        if (raw.description !== undefined && raw.description !== null && raw.description !== '') return raw.description;
        if (raw.values?.['Description'] !== undefined && raw.values?.['Description'] !== null && raw.values?.['Description'] !== '') return raw.values['Description'];
        return '';
      }

      if (matchedGroupName === 'paid' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('paid')))) {
        if (raw.paid !== undefined && raw.paid !== null && raw.paid !== '') return raw.paid;
        return '';
      }

      if (matchedGroupName === 'balance' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('balance')))) {
        if (raw.balance !== undefined && raw.balance !== null && raw.balance !== '') return raw.balance;
        return '';
      }

      if (matchedGroupName === 'createdDate' || (!matchedGroupName && targetGroupKeys.some(a => (a.includes('created') && !a.includes('by')) || a === 'date'))) {
        if (raw.createdDate !== undefined && raw.createdDate !== null && raw.createdDate !== '') return raw.createdDate;
        return '';
      }

      if (matchedGroupName === 'updatedDate' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('updated') && !a.includes('by')))) {
        if (raw.updatedDate !== undefined && raw.updatedDate !== null && raw.updatedDate !== '') return raw.updatedDate;
        return '';
      }
    }

    return '';
  }

  convertTo12Hour(time: string): string {
    if (!time) {
      return '';
    }
    const t = time.toUpperCase();
    if (t.includes('AM') || t.includes('PM')) {
      return time;
    }
    const [hours, minutes] = time.split(':');
    if (!minutes) return time;
    let h = parseInt(hours, 10);
    const m = minutes.substring(0, 2);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12;
    return `${h}:${m} ${ampm}`;
  }

  trackByValue(index: number, item: any): any {
    return item ? (item.value !== undefined ? item.value : (item.viewValue !== undefined ? item.viewValue : item)) : index;
  }

  shouldUseInlineOptions(filter: any): boolean {
    if (!filter) return false;
    if (filter.options && filter.options.length > 0) return true;
    const p = (filter?.property || '').toLowerCase();
    const n = (filter?.name || '').toLowerCase();
    if (this.url.includes('whatsAppBotFlows') || this.url.includes('leadMeetingSummaryReport') || this.url.includes('botRepliesList')) return true;
    // lead status variants
    if (p === 'statusname' || p === 'c.status_name' || n === 'status name' || n === 'life stage' || n === 'lead status') return false;
    // source
    if (p === 'sourcename' || p === 'g.source_name' || n === 'source name' || n === 'lead source') return false;
    // deal stage
    if (p === 'stage' || p === 'a.stage' || p === 'b.statusname' || p === 'b.status_name' || n === 'deal stage' || n === 'stage' || n === 'stage name') return false;
    // tags
    if (p === 'tagname') return false;
    // users / owner / created-by
    if (n === 'owner' || n === 'created by' || p === 'a.owner_id' || p === 'owneremail' || p === 'createdby' || p === 'created_by' || p === 'a.created_by' || p === 'a.user_name') return false;
    // payment
    if (n === 'type of service') return false;
    // activity type
    if (n === 'activity type') return false;
    // tracker
    if (p === 'tracker' || n === 'tracker') return false;
    // priority
    if (p === 'priority' || n === 'priority') return false;
    // industry / business
    if (p === 'industrytype' || n === 'industry type') return false;
    if (p === 'businesstype' || n === 'business type' || n === 'busniess type') return false;
    // warehouse / location
    if (p === 'warehousename' || p === 'warehouse' || p === 'warehouseid' || n === 'location' || n === 'warehouse' || n === 'warehouse name') return false;
    // supplier
    if (p === 'supplier' || p === 'supplierid' || p === 'suppliername' || n === 'suppliers' || n === 'supplier') return false;
    // tax rate
    if (p === 'taxrateid' || p === 'tax' || n === 'tax rate' || n === 'tax rate name') return false;
    return true;
  }
}

